<template>
  <div v-if="member">
    <div class="row" v-if="member !== null && member !== undefined">
      <v-dialog scrollable v-model="successDialog" persistent max-width="500">
        <material-card
          :title="$t('components.addmemberwizard.saveddialogtitle')"
          :color="$vuetify.theme.themes.light.success"
          icon="done"
        >
          <v-card-actions>
            <v-btn color text @click="close()">
              {{ $t("globals.close") }}
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click="
                successDialog = false;
                $router.push({
                  name: 'memberView',
                  params: { id: memberIdentityId },
                });
              "
            >
              {{ $t("globals.view_details") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="confirmBankAccountDialog"
        persistent
        max-width="500"
      >
        <material-card
          :title="
            $t('components.addmemberwizard.confirm_bank_account_dialog_title')
          "
          :color="$vuetify.theme.themes.light.success"
          icon="done"
        >
          <v-card-actions>
            <v-btn color text @click="confirmBankAccountDialog = false">
              {{ $t("globals.close") }}
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click="
                confirmBankAccountDialog = false;
                saveMember();
              "
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <div class="col-12" style="padding-top: 0">
        <v-stepper v-model="step" vertical class="elevation-0">
          <v-stepper-step
            :complete="step > 1"
            step="1"
            id="member_creation_step1"
            editable
          >
            {{ $t("components.memberwizard.plan_member_information") }}
            <small>
              {{
                $t(
                  "components.memberwizard.fill_in_the_members_personal_information"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card-text>
              <v-form v-model="valid.personalInfo" ref="personalInfoForm">
                <div class="row">
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Title') > -1"
                  >
                    <trans-select
                      :clearable="headersDictionary['Title'].isOptional"
                      :item="member.PersonalInfo"
                      propertyName="Title"
                      :items="options.Models.Title"
                      :label="$t('headers.members_management.Title')"
                      :class="
                        headersDictionary['Title'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Title'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('First Name') > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.First Name')"
                      @change="member.PersonalInfo.FirstName = $event"
                      :value="member.PersonalInfo.FirstName"
                      :rules="columnRules(headersDictionary['First Name'])"
                      :class="
                        headersDictionary['First Name'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Middle Name') > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Middle Name')"
                      :value="member.PersonalInfo.MiddleName"
                      @change="member.PersonalInfo.MiddleName = $event"
                      :rules="columnRules(headersDictionary['Middle Name'])"
                      :class="
                        headersDictionary['Middle Name'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Last Name') > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Last Name')"
                      @change="member.PersonalInfo.LastName = $event"
                      :value="member.PersonalInfo.LastName"
                      :rules="columnRules(headersDictionary['Last Name'])"
                      :class="
                        headersDictionary['Last Name'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Pronoun') > -1
                    "
                  >
                    <trans-select
                      :clearable="headersDictionary['Pronoun'].isOptional"
                      :item="member.PersonalInfo"
                      propertyName="Pronoun"
                      :items="options.Models.Pronoun"
                      :label="$t('headers.members_management.Pronoun')"
                      :class="
                        headersDictionary['Pronoun'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Pronoun'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Suffix') > -1"
                  >
                    <trans-select
                      :clearable="headersDictionary['Suffix'].isOptional"
                      :item="member.PersonalInfo"
                      propertyName="Suffix"
                      :items="options.Models.Suffix"
                      :label="$t('headers.members_management.Suffix')"
                      :class="
                        headersDictionary['Suffix'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Suffix'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('SIN') > -1"
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.SIN')"
                      @input="updateSin"
                      :value="member.SIN"
                      :rules="
                        [$rules.sin].concat(
                          columnRules(headersDictionary['SIN'])
                        )
                      "
                      :class="
                        headersDictionary['SIN'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Certificate') > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :disabled="planIdentity.AutogenerateCertificate"
                      :label="$t('headers.members_management.Certificate')"
                      @change="member.Certificate = $event"
                      :value="member.Certificate"
                      :rules="columnRules(headersDictionary['Certificate'])"
                      :class="
                        headersDictionary['Certificate'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Date Of Birth') >
                      -1
                    "
                  >
                    <pbas-date-picker
                      :clearable="
                        headersDictionary['Date Of Birth'].isOptional
                          ? true
                          : false
                      "
                      :label="$t('headers.members_management.Date Of Birth')"
                      @update-date="member.PersonalInfo.DateOfBirth = $event"
                      :value="member.PersonalInfo.DateOfBirth"
                      :rules="
                        headersDictionary['Date Of Birth'].isOptional === false
                          ? [$rules.dateOfBirth, $rules.required]
                          : [$rules.dateOfBirth]
                      "
                      :class="
                        headersDictionary['Date Of Birth'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :allowedDates="dateOfBirthDates"
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Gender') > -1"
                  >
                    <trans-select
                      :clearable="headersDictionary['Gender'].isOptional"
                      :item="member.PersonalInfo"
                      propertyName="Gender"
                      :items="options.Models.Gender"
                      :label="$t('headers.members_management.Gender')"
                      :class="
                        headersDictionary['Gender'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Gender'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Smoker') > -1"
                  >
                    <v-checkbox
                      :label="$t('headers.members_management.Smoker')"
                      v-model="member.PersonalInfo.IsSmoker"
                    ></v-checkbox>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Has Eligible Dependants'
                      ) > -1
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-container pa-0>
                          <v-row no-gutters>
                            <v-col>
                              <v-checkbox
                                :label="
                                  $t(
                                    'headers.members_management.Has Eligible Dependants'
                                  )
                                "
                                v-model="
                                  member.PersonalInfo.HasEligibleDependants
                                "
                              ></v-checkbox>
                            </v-col>
                            <v-col style="margin-top: 20px; margin-left: 3px">
                              <v-icon v-bind="attrs" v-on="on">help</v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                      <span>
                        {{
                          $t(
                            "components.addmemberwizard.eligible_dependants_tooltip"
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Marital Status') >
                      -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['Marital Status'].isOptional
                      "
                      :item="member.PersonalInfo"
                      propertyName="MaritalStatus"
                      :items="options.Models.MaritalStatus"
                      :label="$t('headers.members_management.Marital Status')"
                      :class="
                        headersDictionary['Marital Status'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Marital Status'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'ProvinceOfResidence'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['ProvinceOfResidence'].isOptional
                      "
                      :item="member.PersonalInfo"
                      propertyName="ProvinceOfResidence"
                      :items="options.Models.Province"
                      :label="
                        $t('headers.members_management.ProvinceOfResidence')
                      "
                      :class="
                        headersDictionary['ProvinceOfResidence'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['ProvinceOfResidence'].isOptional ===
                        false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'ProvinceOfEmployment'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['ProvinceOfEmployment'].isOptional
                      "
                      :item="member.PersonalInfo"
                      propertyName="ProvinceOfEmployment"
                      :items="options.Models.Province"
                      :label="
                        $t('headers.members_management.ProvinceOfEmployment')
                      "
                      :class="
                        headersDictionary['ProvinceOfEmployment'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['ProvinceOfEmployment'].isOptional ===
                        false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Tax Exemption') >
                      -1
                    "
                  >
                    <v-checkbox
                      :label="$t('headers.members_management.Tax Exemption')"
                      v-model="member.PersonalInfo.TaxExemption"
                    ></v-checkbox>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Enrollement Signed At'
                      ) > -1
                    "
                  >
                    <pbas-date-picker
                      :clearable="
                        headersDictionary['Enrollement Signed At'].isOptional
                          ? true
                          : false
                      "
                      :label="
                        $t('headers.members_management.Enrollement Signed At')
                      "
                      @update-date="
                        member.EnrollmentSignedAt = $event;
                        $forceUpdate();
                        $refs.personalInfoForm &&
                          $refs.personalInfoForm.resetValidation();
                      "
                      :value="member.EnrollmentSignedAt"
                      :rules="
                        headersDictionary['Enrollement Signed At']
                          .isOptional === false
                          ? [$rules.required, rules.bothCompleted]
                          : [rules.bothCompleted]
                      "
                      :class="
                        headersDictionary['Enrollement Signed At']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Enrollement Received At'
                      ) > -1
                    "
                  >
                    <pbas-date-picker
                      :clearable="
                        headersDictionary['Enrollement Received At'].isOptional
                          ? true
                          : false
                      "
                      :label="
                        $t('headers.members_management.Enrollement Received At')
                      "
                      @update-date="
                        member.EnrollmentReceivedAt = $event;
                        $forceUpdate();
                        $refs.personalInfoForm &&
                          $refs.personalInfoForm.resetValidation();
                      "
                      :value="member.EnrollmentReceivedAt"
                      :rules="
                        headersDictionary['Enrollement Received At']
                          .isOptional === false
                          ? [$rules.required, rules.bothCompleted]
                          : [rules.bothCompleted]
                      "
                      :class="
                        headersDictionary['Enrollement Received At']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-12"
                    v-if="
                      useDocumentsManagement &&
                      Object.keys(headersDictionary).indexOf('Enrolment Form') >
                        -1
                    "
                  >
                    <multi-file-upload2
                      id="enrollmentId"
                      @emit-upload-start="saving = true"
                      @emit-upload-end="saving = false"
                      :label="$t('headers.members_management.Enrolment Form')"
                      :tags="[selectedPlan.UniqueIdentifier]"
                      :categories="['Enrolment']"
                      :currentFolder="selectedPlan.Name"
                      :zipDownloadUrl="
                        settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                      "
                      :fileUploadUrl="
                        settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                      "
                      @emit-files="
                        bindEnrolmentForm($event);
                        saving = false;
                      "
                      @emit-upload-error="
                        error = $event;
                        saving = false;
                      "
                    />
                  </div>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :loading="saving"
                color="primary"
                :disabled="!valid.personalInfo"
                @click="nextStep"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-step
            v-if="stepExists(2)"
            :complete="step > 2"
            :step="2"
            id="member_creation_step2"
            editable
          >
            {{ $t("components.memberview.contact_information") }}
            <small>
              {{
                $t(
                  "components.memberwizard.fill_in_the_members_contact_information"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content v-if="stepExists(2)" :step="2">
            <v-card-text>
              <v-form v-model="valid.contactInfo" ref="contactInfoForm">
                <div class="row">
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'CommunicationPreference'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['CommunicationPreference'].isOptional
                      "
                      :item="member.ContactInfo"
                      propertyName="CommunicationPreference"
                      :items="options.Models.CommunicationPreference"
                      :label="
                        $t('headers.members_management.CommunicationPreference')
                      "
                      :class="
                        headersDictionary['CommunicationPreference']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['CommunicationPreference']
                          .isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('LanguageChoice') >
                      -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['LanguageChoice'].isOptional
                      "
                      :item="member.ContactInfo"
                      propertyName="LanguageChoice"
                      :items="options.Models.LanguageChoice"
                      :label="$t('headers.members_management.LanguageChoice')"
                      :class="
                        headersDictionary['LanguageChoice'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['LanguageChoice'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                </div>
              </v-form>
              <v-form v-model="valid.address" ref="addressForm">
                <div class="row">
                  <template
                    v-if="
                      Object.keys(headersDictionary).indexOf('Country') > -1
                    "
                  >
                    <div class="col-12 col-md-4 col-lg-3">
                      <trans-select
                        @change="countryChanged"
                        :clearable="true"
                        :item="member.ContactInfo.Address"
                        propertyName="Country"
                        :items="options.Models.Country"
                        :label="$t('headers.members_management.Country')"
                        :class="
                          headersDictionary['Country'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Country'].isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></trans-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        member.ContactInfo.Address.Country &&
                        member.ContactInfo.Address.Country.IsOther
                      "
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.OtherCountry')"
                        @change="
                          member.ContactInfo.Address.OtherCountry = $event
                        "
                        :class="
                          headersDictionary['OtherCountry'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['OtherCountry'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="member.ContactInfo.Address.Country"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Street Number')"
                        @change="
                          member.ContactInfo.Address.StreetNumber = $event
                        "
                        :class="
                          headersDictionary['Street Number'].isOptional ===
                          false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Street Number'].isOptional ===
                          false
                            ? [$rules.streetNumber, $rules.required]
                            : [$rules.streetNumber]
                        "
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="member.ContactInfo.Address.Country"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Street Name')"
                        @change="member.ContactInfo.Address.StreetName = $event"
                        :class="
                          headersDictionary['Street Name'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['Street Name'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="member.ContactInfo.Address.Country"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Suite Number')"
                        @change="
                          member.ContactInfo.Address.SuiteNumber = $event
                        "
                        :class="
                          headersDictionary['Suite Number'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['Suite Number'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="member.ContactInfo.Address.Country"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.City')"
                        @change="member.ContactInfo.Address.City = $event"
                        :class="
                          headersDictionary['City'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['City'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        member.ContactInfo.Address.Country &&
                        !member.ContactInfo.Address.Country.IsOther
                      "
                    >
                      <trans-select
                        :clearable="headersDictionary['Province'].isOptional"
                        :item="member.ContactInfo.Address"
                        propertyName="Province"
                        :items="options.Models.Province"
                        :label="$t('headers.members_management.Province')"
                        :class="
                          headersDictionary['Province'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Province'].isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></trans-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        member.ContactInfo.Address.Country &&
                        member.ContactInfo.Address.Country.IsOther
                      "
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.OtherProvince')"
                        @change="
                          member.ContactInfo.Address.OtherProvince = $event
                        "
                        :class="
                          headersDictionary['OtherProvince'].isOptional ===
                          false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['OtherProvince'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        member.ContactInfo.Address.Country &&
                        !member.ContactInfo.Address.Country.IsOther
                      "
                    >
                      <!-- <no-autocomplete-textfield
                        :label="$t('headers.members_management.Postal Code')"
                        @change="member.ContactInfo.Address.PostalCode = $event"
                        :class="
                          headersDictionary['Postal Code'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          columnRules(
                            headersDictionary['Postal Code'],
                            postalCodeMask
                          )
                        "
                        v-mask="postalCodeMask"
                      ></no-autocomplete-textfield> -->
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Postal Code')"
                        @change="member.ContactInfo.Address.PostalCode = $event"
                        :class="
                          headersDictionary['Postal Code'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="columnRules(headersDictionary['Postal Code'])"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        member.ContactInfo.Address.Country &&
                        member.ContactInfo.Address.Country.IsOther
                      "
                    >
                      <no-autocomplete-textfield
                        :label="
                          $t('headers.members_management.OtherPostalCode')
                        "
                        @change="
                          member.ContactInfo.Address.OtherPostalCode = $event
                        "
                        :class="
                          headersDictionary['OtherPostalCode'].isOptional ===
                          false
                            ? 'required'
                            : []
                        "
                        :rules="
                          columnRules(headersDictionary['OtherPostalCode'])
                        "
                      ></no-autocomplete-textfield>
                    </div>
                  </template>
                </div>
              </v-form>
              <v-form v-model="valid.contactInfo2" ref="contactInfoForm2">
                <div class="row">
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Phone Number') >
                      -1
                    "
                  >
                    <!-- <no-autocomplete-textfield
                      :label="$t('headers.members_management.Phone Number')"
                      @change="member.ContactInfo.PhoneNumber = $event"
                      :rules="
                        columnRules(
                          headersDictionary['Phone Number'],
                          telephoneMask
                        )
                      "
                      :class="
                        headersDictionary['Phone Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                      v-mask="telephoneMask"
                    ></no-autocomplete-textfield> -->
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Phone Number')"
                      @change="member.ContactInfo.PhoneNumber = $event"
                      :rules="columnRules(headersDictionary['Phone Number'])"
                      :class="
                        headersDictionary['Phone Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Email') > -1"
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Email')"
                      @change="member.Email = $event"
                      :rules="
                        [rules.confirmEmail].concat(
                          columnRules(headersDictionary['Email'])
                        )
                      "
                      :class="
                        headersDictionary['Email'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="Object.keys(headersDictionary).indexOf('Email') > -1"
                  >
                    <no-autocomplete-textfield
                      :label="$t('components.addmemberwizard.confirm_email')"
                      @change="confirmEmail = $event"
                      :rules="
                        [rules.confirmEmail2].concat(
                          columnRules(headersDictionary['Email'])
                        )
                      "
                      :class="
                        headersDictionary['Email'].isOptional === false
                          ? 'required'
                          : []
                      "
                      @paste="onConfirmEmailPaste"
                    ></no-autocomplete-textfield>
                  </div>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="saving" text @click="step--">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn
                :loading="saving"
                color="primary"
                :disabled="!isContactInfoValid()"
                @click="contactInfoNext"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-step
            v-if="stepExists(3)"
            :complete="step > computeStep(3)"
            :step="computeStep(3)"
            id="member_creation_step3"
            editable
          >
            {{ $t("components.memberview.direct_deposit") }}
            <small>
              {{
                $t(
                  "components.memberwizard.fill_in_the_members_direct_deposit_information"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content v-if="stepExists(3)" :step="computeStep(3)">
            <v-card-text>
              <v-form v-model="valid.bankAccount" ref="bankAccountForm">
                <div class="row">
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Institution Number'
                      ) > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="
                        $t('headers.members_management.Institution Number')
                      "
                      @change="member.BankAccount.InstitutionNumber = $event"
                      :rules="
                        [$rules.canadianBankInstitutionNumber].concat(
                          columnRules(headersDictionary['Institution Number'])
                        )
                      "
                      :class="
                        headersDictionary['Institution Number'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Account Number') >
                      -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Account Number')"
                      @change="member.BankAccount.AccountNumber = $event"
                      :rules="
                        [$rules.canadianBankAccountNumber].concat(
                          columnRules(headersDictionary['Account Number'])
                        )
                      "
                      :class="
                        headersDictionary['Account Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Transit Number') >
                      -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Transit Number')"
                      @change="member.BankAccount.TransitNumber = $event"
                      :rules="
                        [$rules.canadianBankTransitNumber].concat(
                          columnRules(headersDictionary['Transit Number'])
                        )
                      "
                      :class="
                        headersDictionary['Transit Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <!-- <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Account Type') >
                        -1
                    "
                  >
                    <trans-select
                      :clearable="headersDictionary['Account Type'].isOptional"
                      :item="member.BankAccount"
                      propertyName="AccountType"
                      :items="options.Models.AccountType"
                      :label="$t('headers.members_management.Account Type')"
                      :class="
                        headersDictionary['Account Type'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Account Type'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div> -->
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Verify Direct Deposit'
                      ) > -1
                    "
                  >
                    <v-checkbox
                      :label="
                        $t('headers.members_management.Verify Direct Deposit')
                      "
                      v-model="member.BankAccount.VerifyDirectDeposit"
                    ></v-checkbox>
                  </div>
                  <!-- <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Currency') > -1
                        "
                      >
                        <trans-select
                          :clearable="headersDictionary['Currency'].isOptional"
                          :item="member.BankAccount"
                          propertyName="Currency"
                          :items="options.Models.Currency"
                          :label="$t('headers.members_management.Currency')"
                          :class="
                            headersDictionary['Currency'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Currency'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div> -->
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="saving" text @click="step--">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn
                :loading="saving"
                color="primary"
                :disabled="!isBankAccountValid()"
                @click="step++"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-step
            :complete="step > computeStep(4)"
            :step="computeStep(4)"
            id="member_creation_step4"
            editable
          >
            {{ $t("components.memberview.employment_information") }}
            <small>
              {{
                $t(
                  "components.memberwizard.fill_in_the_members_employment_information_and_earnings"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content :step="computeStep(4)">
            <v-card-text>
              <v-form v-model="valid.employmentInfo" ref="employmentInfoForm">
                <div class="row">
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Employer') > -1
                    "
                  >
                    <trans-select2
                      :disabled="true"
                      v-model="member.EmploymentInfo"
                      propertyName="Employer"
                      :items="employers"
                      :label="$t('headers.members_management.Employer')"
                      field="Name"
                      itemValue="Id"
                      :class="
                        headersDictionary['Employer'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Employer'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select2>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Store') > -1 &&
                      stores &&
                      stores.length > 0
                    "
                  >
                    <trans-select2
                      v-model="member.EmploymentInfo"
                      propertyName="Store"
                      :items="stores"
                      :label="$t('headers.members_management.Store')"
                      field="Name"
                      itemValue="Id"
                      :class="
                        headersDictionary['Store'].isOptional === false ||
                        (stores.length > 0 && planOptions.HasStores)
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Store'].isOptional === false ||
                        (stores.length > 0 && planOptions.HasStores)
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select2>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Hire Date') > -1
                    "
                  >
                    <pbas-date-picker
                      :clearable="
                        headersDictionary['Hire Date'].isOptional ? true : false
                      "
                      :label="$t('headers.members_management.Hire Date')"
                      @update-date="member.EmploymentInfo.HireDate = $event"
                      :value="member.EmploymentInfo.HireDate"
                      :class="
                        headersDictionary['Hire Date'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Hire Date'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Employer Contribution'
                      ) > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="
                        $t('headers.members_management.Employer Contribution')
                      "
                      @change="
                        member.EmploymentInfo.EmployerContribution = $event
                      "
                      :value="member.EmploymentInfo.EmployerContribution"
                      :rules="
                        columnRules(headersDictionary['Employer Contribution'])
                      "
                      :class="
                        headersDictionary['Employer Contribution']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Employee Number'
                      ) > -1
                    "
                  >
                    <no-autocomplete-textfield
                      :label="$t('headers.members_management.Employee Number')"
                      @change="member.EmploymentInfo.EmployeeNumber = $event"
                      :value="member.EmploymentInfo.EmployeeNumber"
                      :rules="columnRules(headersDictionary['Employee Number'])"
                      :class="
                        headersDictionary['Employee Number'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Occupation') >
                        -1 && employmentInfoEffectiveDateLoaded
                    "
                  >
                    <auto-select
                      ref="occupation"
                      @keydown="occupationKeyDown"
                      clear-icon="clear"
                      :clearable="headersDictionary['Occupation'].isOptional"
                      :label="$t('headers.members_management.Occupation')"
                      :value.sync="member.EmploymentInfo.Occupation"
                      :items="occupations"
                      :class="
                        headersDictionary['Occupation'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Occupation'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></auto-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Employment Type'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['Employment Type'].isOptional
                      "
                      :item="member.EmploymentInfo"
                      propertyName="EmploymentType"
                      :items="options.Models.EmploymentType"
                      :label="$t('headers.members_management.Employment Type')"
                      :class="
                        headersDictionary['Employment Type'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Employment Type'].isOptional ===
                        false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Employment Frequency'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['Employment Frequency'].isOptional
                      "
                      :item="member.EmploymentInfo"
                      propertyName="EmploymentFrequency"
                      :items="options.Models.EmploymentFrequency"
                      :label="
                        $t('headers.members_management.Employment Frequency')
                      "
                      :class="
                        headersDictionary['Employment Frequency'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Employment Frequency'].isOptional ===
                        false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('WeeklyHours') > -1
                    "
                  >
                    <no-autocomplete-textfield
                      type="text"
                      :label="$t('headers.members_management.WeeklyHours')"
                      @change="member.EmploymentInfo.WeeklyHours = $event"
                      :value="member.EmploymentInfo.WeeklyHours"
                      :class="
                        headersDictionary['WeeklyHours'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['WeeklyHours'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Earnings') > -1
                    "
                  >
                    <currency-textfield
                      :value="member.EmploymentInfo.Earnings"
                      @change="member.EmploymentInfo.Earnings = $event"
                      :label="$t('headers.members_management.Earnings')"
                      :class="
                        headersDictionary['Earnings'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Earnings'].isOptional === false
                          ? [$rules.requiredNum]
                          : []
                      "
                    />
                    <!-- <no-autocomplete-textfield
                      @blur="earningsBlur"
                      :label="$t('headers.members_management.Earnings')"
                      @change="member.EmploymentInfo.Earnings = $event"
                      prefix="$"
                      @keydown="currencyKeydown"
                      @keyup="currencyKeyUp"
                      :class="
                        headersDictionary['Earnings'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Earnings'].isOptional === false
                          ? [$rules.requiredNum, $rules.decimal2]
                          : [$rules.decimal2]
                      "
                    ></no-autocomplete-textfield> -->
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Second Income Earnings Frequency'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['Second Income Earnings Frequency']
                          .isOptional
                      "
                      :item="member.EmploymentInfo"
                      propertyName="SecondIncomeEarningsFrequency"
                      :items="options.Models.SecondIncomeEarningsFrequency"
                      :label="
                        $t(
                          'headers.members_management.Second Income Earnings Frequency'
                        )
                      "
                      :class="
                        headersDictionary['Second Income Earnings Frequency']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Second Income Earnings Frequency']
                          .isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Second Income Type'
                      ) > -1
                    "
                  >
                    <trans-select
                      :clearable="
                        headersDictionary['Second Income Type'].isOptional
                      "
                      :item="member.EmploymentInfo"
                      propertyName="SecondIncomeType"
                      :items="options.Models.SecondIncomeType"
                      :label="
                        $t('headers.members_management.Second Income Type')
                      "
                      :class="
                        headersDictionary['Second Income Type'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Second Income Type'].isOptional ===
                        false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Second Income Earnings'
                      ) > -1
                    "
                  >
                    <currency-textfield
                      @change="
                        member.EmploymentInfo.SecondIncomeEarnings = $event
                      "
                      :value="member.EmploymentInfo.SecondIncomeEarnings"
                      :label="
                        $t('headers.members_management.Second Income Earnings')
                      "
                      :class="
                        headersDictionary['Earnings'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Earnings'].isOptional === false
                          ? [$rules.requiredNum]
                          : []
                      "
                    />
                    <!-- <no-autocomplete-textfield
                      :label="
                        $t('headers.members_management.Second Income Earnings')
                      "
                      @change="
                        member.EmploymentInfo.SecondIncomeEarnings = $event
                      "
                      prefix="$"
                      @keydown="currencyKeydown"
                      @keyup="currencyKeyUp"
                      :class="
                        headersDictionary['Second Income Earnings']
                          .isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Second Income Earnings']
                          .isOptional === false
                          ? [$rules.requiredNum, $rules.decimal2]
                          : [$rules.decimal2]
                      "
                    ></no-autocomplete-textfield> -->
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Salary Evidence Provided'
                      ) > -1
                    "
                  >
                    <v-checkbox
                      :label="
                        $t(
                          'headers.members_management.Salary Evidence Provided'
                        )
                      "
                      v-model="member.EmploymentInfo.SalaryEvidenceProvided"
                    ></v-checkbox>
                    <!-- <v-checkbox
                      :label="
                        $t(
                          'headers.members_management.Salary Evidence Provided'
                        )
                      "
                      @change="
                        member.EmploymentInfo.SalaryEvidenceProvided = $event;
                        $forceUpdate();
                      "
                    ></v-checkbox> -->
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-12"
                    v-if="
                      useDocumentsManagement &&
                      Object.keys(headersDictionary).indexOf(
                        'Salary Evidence'
                      ) > -1 &&
                      member.EmploymentInfo.SalaryEvidenceProvided === true
                    "
                  >
                    <multi-file-upload2
                      id="salaryId"
                      @emit-upload-end="saving = false"
                      :files="enrolmentFiles"
                      @emit-upload-start="saving = true"
                      :label="
                        $t('headers.members_management.Salary Information')
                      "
                      :tags="[selectedPlan.UniqueIdentifier]"
                      :categories="['SalaryEvidence']"
                      :currentFolder="selectedPlan.Name"
                      :zipDownloadUrl="
                        settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                      "
                      :fileUploadUrl="
                        settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                      "
                      @emit-files="
                        bindSalaryInformation($event);
                        saving = false;
                      "
                      @emit-upload-error="
                        error = $event;
                        saving = false;
                      "
                    />
                  </div>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="saving" text @click="step--">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn
                :loading="saving"
                color="primary"
                :disabled="!valid.employmentInfo"
                @click="nextStep"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-step
            :complete="step > computeStep(5)"
            :step="computeStep(5)"
            id="member_creation_step5"
            editable
          >
            {{
              selectedPlan.PlanType === "Pension"
                ? $t("components.memberwizard.spousal_information")
                : $t("globals.dependants")
            }}
            <small>
              {{ $t("components.memberwizard.add_the_members_dependants") }}
            </small>
          </v-stepper-step>
          <v-stepper-content :step="computeStep(5)">
            <v-card-text>
              <div class="row">
                <div class="col-12">
                  <in-memory-dependants
                    :files="enrolmentFiles"
                    @file-upload-start="saving = true"
                    @file-upload-end="saving = false"
                    ref="dependantsTable"
                    @changed-added="dependantsChangedAdded($event)"
                    @changed-updated="dependantsChangedUpdated($event)"
                    @changed-removed="dependantsChangedRemoved($event)"
                    :dependants="dependants.filter((o) => o.IsRemoved !== true)"
                    identifier="membersEditDependants"
                    :maritalStatus="member.PersonalInfo.MaritalStatus"
                  ></in-memory-dependants>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="saving" text @click="step--">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn :loading="saving" color="primary" @click="step++">
                {{ $t("globals.continue") }}
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-step
            :complete="step > computeStep(6)"
            :step="computeStep(6)"
            id="member_creation_step6"
            :editable="coverageStepEditable()"
          >
            {{ $t("components.memberwizard.membership_status") }}
            <small>
              {{
                $t(
                  "components.memberwizard.fill_in_the_membership_status_and_optionally_add_flags"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content :step="computeStep(6)">
            <v-card-text>
              <v-form v-model="valid.membershipStatus">
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-3">
                    <pbas-date-picker
                      :label="
                        $t('components.memberview.coverage_effective_date')
                      "
                      :value="member.MembershipStatus.EffectiveDate"
                      @update-date="
                        member.MembershipStatus.EffectiveDate = $event
                      "
                      :allowedDates="coverageAllowedDates"
                      class="required"
                      :rules="[$rules.required, rules.coverageEffectiveDate]"
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      planIdentity.CurrentPlanMemberEligibility &&
                      planIdentity.CurrentPlanMemberEligibility
                        .IncludeWaitingPeriod
                    "
                  >
                    <v-checkbox
                      :label="
                        $t('components.addmemberwizard.waive_waiting_period')
                      "
                      v-model="member.MembershipStatus.WaiveWaitingPeriod"
                    ></v-checkbox>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Termination Date'
                      ) > -1
                    "
                  >
                    <pbas-date-picker
                      :label="$t('headers.members_management.Termination Date')"
                      :value="member.CoverageExpiryDate"
                      @update-date="member.CoverageExpiryDate = $event"
                      :allowedDates="coverageExpireAllowedDates"
                      :class="
                        headersDictionary['Termination Date'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Termination Date'].isOptional ===
                        false
                          ? [$rules.required, rules.coverageExpireDate]
                          : [rules.coverageExpireDate]
                      "
                    ></pbas-date-picker>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      member.CoverageExpiryDate !== null &&
                      member.CoverageExpiryDate !== undefined &&
                      member.CoverageExpiryDate !== '' &&
                      Object.keys(headersDictionary).indexOf(
                        'Termination Status'
                      ) > -1
                    "
                  >
                    <!-- <auto-select
                      :value.sync="member.CoverageExpiryReason"
                      :items="options.Enums.TerminationStatus"
                      :label="
                        $t('components.addmemberwizard.coverage_expiry_reason')
                      "
                      class="required"
                      :rules="[$rules.required]"
                      :slots="true"
                      :filter="filterFunc"
                    >
                      <template v-slot:selection="data">
                        {{ $t("enums." + data.item) }}
                      </template>
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="$t('enums.' + data.item)"
                        ></v-list-item-content>
                      </template>
                    </auto-select> -->
                    <trans-enum
                      :value.sync="member.CoverageExpiryReason"
                      :items="options.Enums.TerminationStatus"
                      :label="
                        $t('components.addmemberwizard.coverage_expiry_reason')
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-enum>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="hasCoverageCommencementRules"
                  >
                    <v-checkbox
                      :label="
                        $t(
                          'components.addmemberwizard.override_commencement_rules'
                        )
                      "
                      v-model="overrideCommencementRules"
                    ></v-checkbox>
                  </div>
                </div>
              </v-form>
              <v-card
                v-if="
                  !hasCoverageCommencementRules || overrideCommencementRules
                "
              >
                <v-card-title>
                  {{ $t("components.memberview.coverage_choice") }}
                </v-card-title>
                <v-card-text>
                  <v-form ref="form2" v-model="valid.membershipStatus2">
                    <div class="row">
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Default Coverage Status'
                          ) > -1
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-container pa-0>
                              <v-row no-gutters>
                                <v-col>
                                  <trans-select
                                    :clearable="
                                      headersDictionary[
                                        'Default Coverage Status'
                                      ].isOptional
                                    "
                                    :item="member.MembershipStatus"
                                    propertyName="DefaultCoverageStatus"
                                    :items="options.Models.FamilyStatus"
                                    :label="
                                      $t(
                                        'headers.members_management.Default Coverage Status'
                                      )
                                    "
                                    :class="
                                      headersDictionary[
                                        'Default Coverage Status'
                                      ].isOptional === false
                                        ? 'required'
                                        : []
                                    "
                                    :rules="
                                      headersDictionary[
                                        'Default Coverage Status'
                                      ].isOptional === false
                                        ? [$rules.required]
                                        : []
                                    "
                                  ></trans-select>
                                </v-col>
                                <v-col
                                  style="margin-top: 20px; margin-left: 3px"
                                  cols="auto"
                                >
                                  <v-icon v-bind="attrs" v-on="on">help</v-icon>
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>
                          <span>
                            {{
                              $t(
                                "components.addmemberwizard.default_coverage_status_tooltip"
                              )
                            }}
                          </span>
                        </v-tooltip>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Class') > -1
                        "
                      >
                        <auto-select
                          clear-icon="clear"
                          :clearable="headersDictionary['Class'].isOptional"
                          :label="$t('headers.members_management.Class')"
                          :value.sync="member.MembershipStatus.Class"
                          :items="classes"
                          :class="
                            headersDictionary['Class'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Class'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></auto-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Member Group'
                          ) > -1
                        "
                      >
                        <trans-select2
                          v-model="member.MembershipStatus.MemberGroupIdentity"
                          propertyName="Current"
                          :items="memberGroups"
                          :label="$t('headers.members_management.Member Group')"
                          :rules="[$rules.required]"
                          field="Name"
                          itemValue="IdentityId"
                          class="required"
                        ></trans-select2>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="optionalCoverage.length > 0"
                      >
                        <trans-multi-select2
                          v-model="selectedOptionalCoverage"
                          :items="optionalCoverage"
                          :label="
                            $t('components.addmemberwizard.optionalCoverage')
                          "
                          field="Name"
                          itemValue="Id"
                          transPropertyName="Current"
                          @change="optionalChanged"
                        ></trans-multi-select2>
                      </div>
                    </div>
                  </v-form>
                </v-card-text>
              </v-card>
              <div
                class="row"
                v-if="
                  !planIdentity.HasEligibilityBank &&
                  (!hasCoverageCommencementRules || overrideCommencementRules)
                "
              >
                <div class="col-12 col-md-8">
                  <v-card>
                    <v-card-title>
                      {{ $t("components.memberview.customizable_coverage") }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        ref="benefitsTable"
                        :dataProvider="benefitsProvider"
                        :rowActions="rowActions"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        :showActionsBtn="true"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
                <div class="col-12 col-md-4">
                  <v-card>
                    <v-card-title>
                      {{
                        $t("components.memberview.non_customizable_coverage")
                      }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        ref="nonCustomizedBenefitsTable"
                        :dataProvider="nonCustomizedBenefitsProvider"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="saving" text @click="step--">
                {{ $t("globals.back") }}
              </v-btn>
              <!-- <v-btn
                v-if="stepExists(7) || stepExists(8)"
                :loading="saving"
                color="primary"
                :disabled="!valid.membershipStatus || !isCoverageValid()"
                @click="
                  step++;
                  coverageParametersStepEditable = true;
                "
              >
                {{ $t("globals.continue") }}
              </v-btn> -->
              <!-- <div  v-else> -->
              <!-- <v-btn
                v-else
                :loading="saving"
                :disabled="!isValid()"
                color="primary"
                @click="save"
              >
                {{ $t("globals.finish") }}
              </v-btn> -->
            </v-card-actions>
          </v-stepper-content>
        </v-stepper>
      </div>
      <v-dialog scrollable v-model="cobDialog" persistent max-width="800">
        <material-card
          v-if="selectedBenefit"
          :title="trans2(selectedBenefit.CoverageIdentity.Current, 'Name')"
          :color="$vuetify.theme.themes.light.success"
          icon="done"
        >
          <v-card-text>
            <v-form v-model="valid.cob">
              <div class="row">
                <div class="col-12 col-md-4">
                  <no-autocomplete-textfield
                    :label="$t('globals.insurance_carrier')"
                    v-model="selectedBenefit.COB.InsuranceCarrier"
                    class="required"
                    :rules="[$rules.required]"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-md-4">
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.policy_no')"
                    v-model="selectedBenefit.COB.PolicyNumber"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-md-4">
                  <pbas-date-picker
                    :label="$t('components.inmemorydependants.effective_date')"
                    :value="selectedBenefit.COB.EffectiveDate"
                    @update-date="selectedBenefit.COB.EffectiveDate = $event"
                    class="required"
                    :rules="[$rules.required]"
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4"
                  v-if="
                    selectedBenefit.CoverageIdentity.CoverageType === 'Health'
                  "
                >
                  <v-autocomplete
                    v-model="selectedBenefit.COB.HealthCobTypes"
                    :items="columnsDropDownOptions.Enums.HealthCobType"
                    :label="$t('components.addmemberwizard.covered_benefits')"
                    multiple
                    class="required"
                    :rules="[$rules.atLeastOne]"
                    :item-text="(item) => $t('enums.' + item)"
                  >
                    <!-- <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template> -->
                  </v-autocomplete>
                </div>
                <div class="col-12 col-md-4">
                  <trans-select
                    :item="selectedBenefit.COB"
                    propertyName="CoverageStatus"
                    :items="columnsDropDownOptions.Models.FamilyStatus"
                    :label="$t('components.addmemberwizard.coverage_status')"
                    :multiple="false"
                  ></trans-select>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color text @click="cobDialog = false">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn :disabled="!valid.cob" color="primary" @click="saveCob">
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="editCoverageDialog"
        persistent
        max-width="800"
      >
        <material-card
          v-if="selectedBenefit"
          :title="trans2(selectedBenefit.CoverageIdentity.Current, 'Name')"
          :color="$vuetify.theme.themes.light.success"
          icon="done"
        >
          <v-card-text>
            <v-form v-model="valid.editCoverage">
              <div class="row">
                <div
                  class="col-12 col-md-4"
                  v-if="
                    selectedBenefit &&
                    selectedBenefit.CoverageIdentity.Current.HasCoverageChoice
                  "
                >
                  <trans-select
                    :disabled="
                      selectedBenefit.CoverageIdentity.Current
                        .RestrictToDefaultCoverageStatus
                    "
                    :item="selectedBenefit"
                    propertyName="CoverageStatus"
                    :items="selectableFamilyStatuses"
                    :label="$t('components.addmemberwizard.coverage_status')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4"
                  v-if="
                    selectedBenefit &&
                    selectedBenefit.CoverageStatus &&
                    tracksDependantsByNumber(selectedBenefit)
                  "
                >
                  <auto-select
                    :rules="[$rules.requiredNum]"
                    class="required"
                    :label="$t('headers.members_management.No Of Dependants')"
                    :value.sync="selectedBenefit.NoOfDependants"
                    :items="
                      selectableNoOfDependants(selectedBenefit.CoverageStatus)
                    "
                    return-object
                  ></auto-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    selectedBenefit &&
                    selectedBenefit.CoverageStatus &&
                    tracksDependantsByName(selectedBenefit)
                  "
                >
                  <auto-select
                    :value.sync="selectedBenefit.Dependants"
                    :items="dependants"
                    :label="$t('globals.dependants')"
                    :rules="
                      Array.isArray(selectedBenefit.Dependants)
                        ? [$rules.atLeastOne]
                        : [$rules.required]
                    "
                    class="required"
                    :slots="true"
                    :filter="filterFunc"
                    item-value="Identifier"
                    multiple
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeDependant(data.item)"
                      >
                        {{ data.item.FirstName + " " + data.item.LastName }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="
                              data.item.FirstName + ' ' + data.item.LastName
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="trans(data.item.Relationship)"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                    <!-- <template v-slot:selection="data">{{ data.item.FirstName + ' ' + data.item.LastName }}</template>
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.FirstName + ' ' + data.item.LastName"></v-list-item-content>
                    </template> -->
                  </auto-select>
                </div>
                <div
                  class="col-12 col-md-4"
                  v-if="
                    selectedBenefit.CoverageIdentity.Current.HasVolumeChoice
                  "
                >
                  <currency-textfield
                    v-model="selectedBenefit.Volume"
                    :label="$t('globals.value')"
                    class="required"
                    :rules="[$rules.requiredNum, rules.minmax]"
                  />
                  <!-- <no-autocomplete-textfield
                    :label="$t('components.plancreationwizard.volume')"
                    v-model="selectedBenefit.Volume"
                    prefix="$"
                    @keydown="currencyKeydown"
                    @keyup="currencyKeyUp"
                    :rules="[$rules.required, rules.minmax]"
                    class="required"
                  ></no-autocomplete-textfield> -->
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color text @click="editCoverageDialog = false">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!valid.editCoverage"
              color="primary"
              @click="saveCoverage"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </div>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { translate } from "../trans";
import { translate2 } from "../trans2";
import TransSelect from "../components/TransSelect";
import TransSelect2 from "../components/TransSelect2";
import TransMultiSelect2 from "../components/TransMultiSelect2";
import ApiService from "../services/api.service";
import InMemoryDependants from "../components/InMemoryDependants";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";
import { InMemoryProvider } from "pbas-vue-components";
import BenefitHeaders from "../headers/Benefits";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import NonCustomizedBenefitHeaders from "../headers/NonCustomizedBenefits";
import { createMemberFile } from "../makeMemberFile";
import MultiFileUpload2 from "../components/MultiFileUpload2.vue";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { planSetter } from "../mixins/planSetter";
import CurrencyTextfield from "../components/CurrencyTextfield.vue";
import TransEnum from "../components/TransEnum.vue";
import SettingsService from "@/services/settings.service.js";

export default {
  name: "add-member-wizard",
  components: {
    TransSelect,
    TransSelect2,
    TransMultiSelect2,
    InMemoryDependants,
    ErrorHandler,
    AutoSelect,
    NoAutocompleteTextfield,
    MultiFileUpload2,
    CurrencyTextfield,
    TransEnum,
  },
  directives: { mask },
  mixins: [planSetter],
  data() {
    return {
      loadingMember: false,
      createCustomCoverage: false,
      postalCodeMask: "A#A #A#",
      telephoneMask: "(###) ### - ####",
      confirmBankAccountDialog: false,
      branchName: "",
      enrolmentFiles: [],
      coverageParametersStepEditable: false,
      allPlanInsuranceCarriers: [],
      selectedStatement: null,
      hasPreviousDeclarationDate: false,
      beneficiaryStatements: [],
      planInsuranceCarriers: [],
      previousBeneficiaryPayload: null,
      newBeneficiaryStatement: false,
      hasCoverageCommencementRules: false,
      overrideCommencementRules: false,
      beneficiariesFloatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.previousBeneficiaryPayload = {
              Id: Math.random(),
              DeclarationDate: this.member.MembershipStatus.EffectiveDate, //Intl.DateTimeFormat("fr-CA").format(new Date()),
              Beneficiaries: [],
              PlanInsuranceCarriers: [],
            };
            this.newBeneficiaryStatement = true;
            this.selectedStatement = undefined;
            this.beneficiariesDialog = true;
          },
        },
      ],
      beneficiariesRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.previousBeneficiaryPayload = null;
            this.newBeneficiaryStatement = false;
            this.selectedStatement = item;
            this.beneficiariesDialog = true;
            // this.$nextTick(() => {
            console.log(item);

            // });
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.deleteBeneficiaryStatement(item);
          },
        },
      ],
      beneficiariesProvider: undefined,
      beneficiariesDialog: false,
      checkDependants: true,
      // oldFamilyStatus: null,
      editCoverageDialog: false,
      selectedDependants: [],
      cobDialog: false,
      selectedBenefit: null,
      benefitsProvider: undefined,
      nonCustomizedBenefitsProvider: undefined,
      rowActions: [
        {
          name: "waive",
          icon: "done",
          title: "components.addmemberwizard.waive",
          handler: (item) => {
            const selected = this.benefitsProvider.items.filter(
              (o) => o.CoverageIdentityId === item.CoverageIdentityId
            )[0];
            const index = this.benefitsProvider.items.indexOf(selected);
            this.benefitsProvider.items[index].IsWaived = true;
            this.$refs.benefitsTable.getDataAsync();
            this.$forceUpdate();
          },
          visible: (item) => {
            return (
              item.CoverageIdentity.Current.IsWaivable === true &&
              (item.IsWaived === false ||
                item.IsWaived === undefined ||
                item.IsWaived === null)
            );
          },
        },
        {
          name: "unwaive",
          icon: "remove_done",
          title: "components.addmemberwizard.unwaive",
          handler: (item) => {
            const selected = this.benefitsProvider.items.filter(
              (o) => o.CoverageIdentityId === item.CoverageIdentityId
            )[0];
            const index = this.benefitsProvider.items.indexOf(selected);
            this.benefitsProvider.items[index].IsWaived = false;
            this.$refs.benefitsTable.getDataAsync();
          },
          visible: (item) => {
            return (
              item.CoverageIdentity.Current.IsWaivable === true &&
              item.IsWaived === true
            );
          },
        },
        {
          name: "cob",
          icon: "deck",
          title: "headers.benefits.cob",
          handler: (item) => {
            // this.$router.push({ name: "memberView", params: { id: item.Id } });
            this.selectedBenefit = JSON.parse(JSON.stringify(item));
            this.cobDialog = true;
          },
          visible: (item) => {
            return (
              (item.IsWaived === false ||
                item.IsWaived === undefined ||
                item.IsWaived === null) &&
              item.CoverageIdentity.Current.HasCOB
            );
          },
        },
        {
          name: "editCoverage",
          icon: "beach_access",
          title: "components.memberview.view_edit_coverage_title",
          handler: (item) => {
            this.selectedBenefit = JSON.parse(JSON.stringify(item));
            this.selectedBenefit.Dependants = this.dependants.map(
              (o) => o.Identifier
            );
            this.editCoverageDialog = true;
          },
          visible: (item) => {
            return (
              (item.IsWaived === false ||
                item.IsWaived === undefined ||
                item.IsWaived === null) &&
              ((item.CoverageIdentity.Current.HasCoverageChoice &&
                !item.CoverageIdentity.Current
                  .RestrictToDefaultCoverageStatus &&
                this.member.MembershipStatus.DefaultCoverageStatus &&
                this.member.MembershipStatus.DefaultCoverageStatus.Id !==
                  this.singleFamilyStatus.Id) ||
                item.CoverageIdentity.Current.HasVolumeChoice)
            );
          },
        },
      ],
      optionalCoverage: [],
      selectedOptionalCoverage: [],
      memberIdentityId: null,
      confirmEmail: null,
      successDialog: false,
      error: null,
      member: null,
      headersDictionary: {},
      step: 1,
      valid: {
        personalInfo: true,
        employmentInfo: true,
        contactInfo: true,
        contactInfo2: true,
        bankAccount: true,
        membershipStatus: true,
        membershipStatus2: true,
        memberBenefits: true,
        address: true,
        cob: true,
        editCoverage: false,
      },
      stores: [],
      saving: false,
      membershipStatusEffectiveDateLoaded: false,
      employmentInfoEffectiveDateLoaded: false,
      memberGroups: [],
      classes: [],
      occupations: [],
      flags: [],
      customizedCoverages: [],
      customizedCoveragesVolumeChoice: [],
      selectableFamilyStatuses: [],
      coverageConfigurationHeaders: [
        {
          text: this.$t("globals.description"),
          value: "Description",
        },
        {
          text: this.$t("globals.type"),
          value: "ParameterType",
          align: "center",
        },
        {
          text: this.$t("components.addmemberwizard.rates"),
          value: "ConfigurationParameterValues",
          align: "right",
        },
        {
          text: this.$t("components.addmemberwizard.rates_mode"),
          value: "isCustom",
          align: "center",
        },
        {
          value: "Reset",
        },
      ],
      coverageConfiguration: [],
      coverageConfigurationLoading: false,
      coverageConfigurationLoaded: false,
      editedValue: -1.0,
      parameterValid: false,
      dependants: [],
      rules: {
        minmax: () => {
          const customCoverage = this.selectedBenefit;
          // console.log(customCoverage);
          const msg = this.$t("components.addmemberwizard.rates_msg_{0}_{1}", [
            customCoverage.CoverageIdentity.Current.MinVolume,
            customCoverage.CoverageIdentity.Current.MaxVolume,
          ]);
          let valid = true;
          if (customCoverage.CoverageIdentity.Current.MinVolume) {
            valid =
              customCoverage.CoverageIdentity.Current.MinVolume <=
              customCoverage.Volume;
          }
          if (!valid) return msg;
          if (customCoverage.CoverageIdentity.Current.MaxVolume) {
            valid =
              customCoverage.CoverageIdentity.Current.MaxVolume >=
              customCoverage.Volume;
          }
          // console.log(msg, valid)
          return valid || msg;
        },
        bothCompleted: (v) => {
          // console.log(
          //   "rules2:",
          //   v,
          //   this.member.EnrollmentSignedAt,
          //   this.member.EnrollmentReceivedAt
          // );
          if (
            this.member.EnrollmentSignedAt === null ||
            this.member.EnrollmentSignedAt === undefined ||
            this.member.EnrollmentSignedAt === ""
          ) {
            return (
              this.member.EnrollmentReceivedAt === null ||
              this.member.EnrollmentReceivedAt === undefined ||
              this.member.EnrollmentReceivedAt === "" ||
              this.$t("components.addmemberwizard.enrollment_received_msg")
            );
          } else if (
            this.member.EnrollmentReceivedAt === null ||
            this.member.EnrollmentReceivedAt === undefined ||
            this.member.EnrollmentReceivedAt === ""
          ) {
            return (
              this.member.EnrollmentSignedAt === null ||
              this.member.EnrollmentSignedAt === undefined ||
              this.member.EnrollmentSignedAt === "" ||
              this.$t("components.addmemberwizard.enrollment_received_msg")
            );
          } else {
            return true;
          }
        },
        confirmEmail: (v) => {
          // console.log(this.confirmEmail, this.member.Email, v, this.confirmEmail === v, )
          if (
            (this.confirmEmail === null || this.confirmEmail === undefined) &&
            (v === null || v === undefined)
          ) {
            return true;
          }
          return (
            this.confirmEmail === v || this.$t("validation.emails_must_match")
          );
        },
        confirmEmail2: (v) => {
          // console.log(this.confirmEmail, this.member.Email, v, v === this.member.Email, )
          if (
            (v === null || v === undefined) &&
            (this.member.Email === null || this.member.Email === undefined)
          ) {
            return true;
          }
          return (
            v === this.member.Email || this.$t("validation.emails_must_match")
          );
        },
        enrollmentSignedAt: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.member === null ||
            this.member === undefined ||
            this.member.EnrollmentSignedAt === null ||
            this.member.EnrollmentSignedAt === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.member.EnrollmentSignedAt);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [this.formatDate(d)]);
          }
          return (
            this.allowedEnrollmentSignedAt(v) ||
            this.$t("validation.date_{0}", [this.formatDate(d)])
          );
        },
        coverageEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (this.member === null || this.member === undefined) {
            return true;
          }
          let firstRenewalTimestamps = Date.parse(
            this.planIdentity.FirstRenewalDate
          );
          let hireTimestamps = null;
          if (
            this.planIdentity.CurrentPlanMemberEligibility &&
            this.planIdentity.CurrentPlanMemberEligibility
              .IncludeWaitingPeriod &&
            !this.member.MembershipStatus.WaiveWaitingPeriod
          ) {
            if (
              this.member.EmploymentInfo === null ||
              this.member.EmploymentInfo === undefined ||
              this.member.EmploymentInfo.HireDate === null ||
              this.member.EmploymentInfo.HireDate === undefined
            ) {
              return true;
            }
            hireTimestamps = Date.parse(this.member.EmploymentInfo.HireDate);
            if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Day"
            ) {
              hireTimestamps = this.addDays(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            } else if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Week"
            ) {
              hireTimestamps = this.addWeeks(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            } else if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Month"
            ) {
              hireTimestamps = this.addMonths(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            }
          } else if (
            Object.keys(this.headersDictionary).indexOf("Hire Date") > -1
          ) {
            if (
              this.member.EmploymentInfo === null ||
              this.member.EmploymentInfo === undefined ||
              this.member.EmploymentInfo.HireDate === null ||
              this.member.EmploymentInfo.HireDate === undefined
            ) {
              return true;
            }
            hireTimestamps = Date.parse(this.member.EmploymentInfo.HireDate);
          }
          const firstRenewalDate = new Date(firstRenewalTimestamps);
          let currentDate = null;
          if (hireTimestamps !== null) {
            const hireDate = new Date(hireTimestamps);
            if (hireDate > firstRenewalDate) {
              currentDate = hireDate;
            }
          }
          if (currentDate === null) {
            currentDate = firstRenewalDate;
          }

          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatDate(currentDate),
            ]);
          }
          return (
            this.coverageAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate(currentDate)])
          );
        },
        coverageExpireDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.member === null ||
            this.member === undefined ||
            this.member.MembershipStatus.EffectiveDate === null ||
            this.member.MembershipStatus.EffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.member.MembershipStatus.EffectiveDate);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [this.formatDate(d)]);
          }
          return (
            this.coverageExpireAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate(d)])
          );
        },
      },
      snackbar: false,
      color: "",
      mode: "",
      timeout: 4500,
      message: "",
    };
  },
  props: [
    "headers",
    "externalMember",
    "pendingImportId",
    "employers",
    "rowId",
    "recreate",
    "termDate",
  ],
  methods: {
    ...mapActions("plansMembers", [
      "getPlanDetailsByDate",
      "getMemberGroupsWithDate",
      "getFlags",
      "getCoverageConfiguration",
      "newMember",
      "getMembersManagementColumns",
      "releaseCertificate",
      "getNewCertificate",
      "validateBankAccount",
      // "getPendingHoursMemberInfo",
      "getPendingHoursNewMember",
      "checkHasCoverageCommencementRules",
    ]),
    updateSin(v) {
      if (v === "") {
        this.member.SIN = null;
      } else {
        this.member.SIN = v;
      }
    },
    occupationKeyDown(keyboardEvent) {
      if (keyboardEvent.keyCode === 13) {
        let id = this.$refs.occupation.randomName;
        let newval = document.getElementById(id).value;
        this.occupations.push(newval);
      }
    },
    removeDependant(item) {
      console.log(this.selectedBenefit.Dependants, item);
      if (Array.isArray(this.selectedBenefit.Dependants)) {
        this.selectedBenefit.Dependants =
          this.selectedBenefit.Dependants.filter((o) => o !== item.Identifier);
      } else {
        this.selectedBenefit.Dependants = null;
      }
    },
    unmask(v, mask) {
      // console.log(v, mask);
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    filterFunc(item, search) {
      // console.log(item);
      return (
        item.FirstName.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        item.LastName.toLowerCase().indexOf(search.toLowerCase()) > -1
      );
    },
    getPlanName() {
      return this.planIdentity.Current.Name + "/members";
    },
    getPlanId() {
      return this.selectedPlan.UniqueIdentifier;
    },
    bindEnrolmentForm(memberFiles) {
      if (memberFiles.length > 0) {
        const files = createMemberFile(memberFiles, "Enrolment");
        this.member.EnrolmentForm = files;
        this.enrolmentFiles = memberFiles;
      } else {
        delete this.member.EnrolmentForm;
        this.enrolmentFiles = [];
      }
      this.$forceUpdate();
    },
    bindSalaryInformation(memberFile) {
      this.member.EmploymentInfo.SalaryEvidence = createMemberFile(
        memberFile,
        "SalaryEvidence"
      );
    },
    coverageStepEditable() {
      if (Object.keys(this.headersDictionary).indexOf("Hire Date") > -1) {
        return (
          this.member.EmploymentInfo.HireDate !== null &&
          this.member.EmploymentInfo.HireDate !== undefined
        );
      }
      return true;
    },
    setCustomizableCoverages() {
      let customizableCoverages =
        this.member.MembershipStatus.MemberGroupIdentity.Current &&
        this.member.MembershipStatus.MemberGroupIdentity.Current
          .CoverageIdentities
          ? this.member.MembershipStatus.MemberGroupIdentity.Current.CoverageIdentities.filter(
              () => true
            )
          : [];
      this.customizedCoverages = [];
      console.log("set customizable coverages: ", customizableCoverages);
      for (let coverage of customizableCoverages) {
        // console.log(coverage.CurrentCoverageEligibility);
        let classes = null;
        if (coverage.CurrentCoverageEligibility) {
          classes = JSON.parse(coverage.CurrentCoverageEligibility.Classes);
        }
        if (classes === null || classes === undefined) {
          classes = [];
        }
        if (
          (!coverage.CurrentCoverageEligibility ||
            !coverage.CurrentCoverageEligibility.DependsOnHasDependants ||
            (coverage.CurrentCoverageEligibility.DependsOnHasDependants &&
              this.member.PersonalInfo.HasEligibleDependants === true)) &&
          (!coverage.CurrentCoverageEligibility ||
            !coverage.CurrentCoverageEligibility.DependsOnCoverageStatus ||
            coverage.CurrentCoverageEligibility.CoverageStatuses.filter(
              (o) =>
                o.Id === this.member.MembershipStatus.DefaultCoverageStatus.Id
            ).length > 0) &&
          (!coverage.CurrentCoverageEligibility ||
            !coverage.CurrentCoverageEligibility.DependsOnClass ||
            classes.filter((o) => o === this.member.MembershipStatus.Class)
              .length > 0) &&
          (!coverage.CurrentCoverageEligibility ||
            !(coverage.CurrentCoverageEligibility.BenefitParty === "Spouse") ||
            this.dependants.filter((o) => o.Relationship.IsSpouse).length >
              0) &&
          (!coverage.CurrentCoverageEligibility ||
            !(coverage.CurrentCoverageEligibility.BenefitParty === "Child") ||
            this.dependants.filter((o) => o.Relationship.IsChild).length > 0)
        ) {
          this.customizedCoverages.push({
            CoverageIdentity: coverage,
            CoverageIdentityId: coverage.Current.IdentityId,
            CoverageStatus: null,
            CoverageStatusId: null,
            EffectiveDate: this.member.MembershipStatus.EffectiveDate,
            Volume: null,
            COB: {},
          });
        }
      }
      for (let benefit of this.customizedCoverages) {
        if (benefit.CoverageIdentity.Current.HasCoverageChoice) {
          if (
            this.member.MembershipStatus.DefaultCoverageStatus &&
            this.member.MembershipStatus.DefaultCoverageStatus.Id ===
              this.singleFamilyStatus.Id
          ) {
            benefit.CoverageStatus = this.singleFamilyStatus;
          }
          if (
            this.member.MembershipStatus.DefaultCoverageStatus &&
            benefit.CoverageIdentity.Current.RestrictToDefaultCoverageStatus
          ) {
            benefit.CoverageStatus = this.options.Models.FamilyStatus.filter(
              (o) =>
                o.Id === this.member.MembershipStatus.DefaultCoverageStatus.Id
            )[0];
          }
          if (
            benefit.CoverageStatus &&
            benefit.CoverageStatus.Id === this.singleFamilyStatus.Id &&
            this.tracksDependantsByNumber(benefit)
          ) {
            benefit.NoOfDependants = 0;
          } else if (
            benefit.CoverageStatus &&
            benefit.CoverageStatus.Id === this.coupleFamilyStatus.Id &&
            this.tracksDependantsByNumber(benefit)
          ) {
            benefit.NoOfDependants = 1;
          }
        }
      }
      if (this.benefitsProvider === undefined) {
        this.benefitsProvider = new InMemoryProvider(
          this.customizedCoverages.filter(
            (o) =>
              o.CoverageIdentity.Current.IsOptional !== true &&
              (o.CoverageIdentity.Current.IsWaivable ||
                o.CoverageIdentity.Current.HasCOB ||
                o.CoverageIdentity.Current.HasCoverageChoice ||
                o.CoverageIdentity.Current.HasVolumeChoice)
          ),
          BenefitHeaders
        );
        this.nonCustomizedBenefitsProvider = new InMemoryProvider(
          this.customizedCoverages.filter(
            (o) =>
              o.CoverageIdentity.Current.IsOptional !== true &&
              !o.CoverageIdentity.Current.IsWaivable &&
              !o.CoverageIdentity.Current.HasCOB &&
              !o.CoverageIdentity.Current.HasCoverageChoice &&
              !o.CoverageIdentity.Current.HasVolumeChoice
          ),
          NonCustomizedBenefitHeaders
        );
      } else {
        this.benefitsProvider.items = this.customizedCoverages.filter(
          (o) =>
            o.CoverageIdentity.Current.IsOptional !== true &&
            (o.CoverageIdentity.Current.IsWaivable ||
              o.CoverageIdentity.Current.HasCOB ||
              o.CoverageIdentity.Current.HasCoverageChoice ||
              o.CoverageIdentity.Current.HasVolumeChoice)
        );
        this.nonCustomizedBenefitsProvider.items =
          this.customizedCoverages.filter(
            (o) =>
              o.CoverageIdentity.Current.IsOptional !== true &&
              !o.CoverageIdentity.Current.IsWaivable &&
              !o.CoverageIdentity.Current.HasCOB &&
              !o.CoverageIdentity.Current.HasCoverageChoice &&
              !o.CoverageIdentity.Current.HasVolumeChoice
          );
        if (this.$refs.benefitsTable) {
          this.$refs.benefitsTable.getDataAsync();
        }
        if (this.$refs.nonCustomizedBenefitsTable) {
          this.$refs.nonCustomizedBenefitsTable.getDataAsync();
        }
      }
      this.optionalCoverage = this.customizedCoverages
        .filter((o) => o.CoverageIdentity.Current.IsOptional === true)
        .map((o) => o.CoverageIdentity);

      // console.log(
      //   this.benefitsProvider.items,
      //   this.nonCustomizedBenefitsProvider.items,
      //   this.optionalCoverage
      // );
    },
    refreshBenefits() {
      if (
        this.member.MembershipStatus.MemberGroupIdentity === null ||
        this.member.MembershipStatus.MemberGroupIdentity === undefined
      ) {
        return;
      }
      if (
        (this.benefitsProvider === null ||
          this.benefitsProvider === undefined) &&
        (this.nonCustomizedBenefitsProvider === null ||
          this.nonCustomizedBenefitsProvider === undefined)
      ) {
        return;
      }
      // console.log("R e f r e s h   B e n e f i t s");

      this.customizedCoverages = this.customizedCoverages.filter((c) => {
        let classes = null;
        if (c.CoverageIdentity.CurrentCoverageEligibility) {
          classes = JSON.parse(
            c.CoverageIdentity.CurrentCoverageEligibility.Classes
          );
        }
        if (classes === null || classes === undefined) {
          classes = [];
        }

        return (
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnHasDependants ||
            (c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnHasDependants &&
              this.member.PersonalInfo.HasEligibleDependants === true)) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnCoverageStatus ||
            c.CoverageIdentity.CurrentCoverageEligibility.CoverageStatuses.filter(
              (o) =>
                o.Id === this.member.MembershipStatus.DefaultCoverageStatus.Id
            ).length > 0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility.DependsOnClass ||
            classes.filter((o) => o === this.member.MembershipStatus.Class)
              .length > 0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !(
              c.CoverageIdentity.CurrentCoverageEligibility.BenefitParty ===
              "Spouse"
            ) ||
            this.dependants.filter((o) => o.Relationship.IsSpouse).length >
              0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !(
              c.CoverageIdentity.CurrentCoverageEligibility.BenefitParty ===
              "Child"
            ) ||
            this.dependants.filter((o) => o.Relationship.IsChild).length > 0)
        );
      });
      let customizableCoverages =
        this.member.MembershipStatus.MemberGroupIdentity.Current &&
        this.member.MembershipStatus.MemberGroupIdentity.Current
          .CoverageIdentities
          ? this.member.MembershipStatus.MemberGroupIdentity.Current.CoverageIdentities.filter(
              (c) => {
                let classes = null;
                if (c.CurrentCoverageEligibility) {
                  classes = JSON.parse(c.CurrentCoverageEligibility.Classes);
                }
                if (classes === null || classes === undefined) {
                  classes = [];
                }
                //  console.log(c.CurrentCoverageEligibility, this.member.PersonalInfo.HasEligibleDependants)
                return (
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnHasDependants ||
                    (c.CurrentCoverageEligibility.DependsOnHasDependants &&
                      this.member.PersonalInfo.HasEligibleDependants ===
                        true)) &&
                  c.Current.IsOptional !== true &&
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnCoverageStatus ||
                    c.CurrentCoverageEligibility.CoverageStatuses.filter(
                      (o) =>
                        o.Id ===
                        this.member.MembershipStatus.DefaultCoverageStatus.Id
                    ).length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnClass ||
                    classes.filter(
                      (o) => o === this.member.MembershipStatus.Class
                    ).length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !(c.CurrentCoverageEligibility.BenefitParty === "Spouse") ||
                    this.dependants.filter((o) => o.Relationship.IsSpouse)
                      .length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !(c.CurrentCoverageEligibility.BenefitParty === "Child") ||
                    this.dependants.filter((o) => o.Relationship.IsChild)
                      .length > 0)
                );
              }
            )
          : [];
      // console.log(JSON.stringify(customizableCoverages));
      customizableCoverages = customizableCoverages.filter(
        (c) =>
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === c.Current.IdentityId
          ).length === 0
      );

      // console.log(customizableCoverages);
      for (const coverage of customizableCoverages) {
        this.customizedCoverages.push({
          CoverageIdentity: coverage,
          CoverageIdentityId: coverage.Current.IdentityId,
          CoverageStatus: null,
          CoverageStatusId: null,
          EffectiveDate: this.member.MembershipStatus.EffectiveDate,
          Volume: null,
          COB: {},
        });
      }
      if (this.member.MembershipStatus.DefaultCoverageStatus) {
        for (let benefit of this.customizedCoverages) {
          if (benefit.CoverageIdentity.Current.HasCoverageChoice) {
            if (
              this.member.MembershipStatus.DefaultCoverageStatus.Id ===
              this.singleFamilyStatus.Id
            ) {
              benefit.CoverageStatus = this.singleFamilyStatus;
            }
            if (
              benefit.CoverageIdentity.Current.RestrictToDefaultCoverageStatus
            ) {
              benefit.CoverageStatus = this.options.Models.FamilyStatus.filter(
                (o) =>
                  o.Id === this.member.MembershipStatus.DefaultCoverageStatus.Id
              )[0];
            }
            if (
              benefit.CoverageStatus &&
              benefit.CoverageStatus.Id === this.singleFamilyStatus.Id &&
              this.tracksDependantsByNumber(benefit)
            ) {
              benefit.NoOfDependants = 0;
            } else if (
              benefit.CoverageStatus &&
              benefit.CoverageStatus.Id === this.coupleFamilyStatus.Id &&
              this.tracksDependantsByNumber(benefit)
            ) {
              benefit.NoOfDependants = 1;
            }
          }
        }
      }

      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          (o.CoverageIdentity.Current.IsOptional !== true ||
            this.selectedOptionalCoverage.filter(
              (c) => c.Current.IdentityId === o.CoverageIdentityId
            ).length > 0) &&
          (o.CoverageIdentity.Current.IsWaivable ||
            o.CoverageIdentity.Current.HasCOB ||
            o.CoverageIdentity.Current.HasCoverageChoice ||
            o.CoverageIdentity.Current.HasVolumeChoice)
      );

      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            (o.CoverageIdentity.Current.IsOptional !== true ||
              this.selectedOptionalCoverage.filter(
                (c) => c.Current.IdentityId === o.CoverageIdentityId
              ).length > 0) &&
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );
      if (this.$refs.benefitsTable) {
        this.$refs.benefitsTable.getDataAsync();
      }
      if (this.$refs.nonCustomizedBenefitsTable) {
        this.$refs.nonCustomizedBenefitsTable.getDataAsync();
      }

      this.optionalCoverage = this.customizedCoverages
        .filter((o) => o.CoverageIdentity.Current.IsOptional === true)
        .map((o) => o.CoverageIdentity);
    },
    optionalChanged($event) {
      let v = $event;

      this.customizedCoverages = this.customizedCoverages.filter(
        (o) =>
          !o.CoverageIdentity.Current.IsOptional ||
          (o.CoverageIdentity.Current.IsOptional &&
            v.filter((c) => c.Current.IdentityId === o.CoverageIdentityId)
              .length > 0)
      );
      for (const cov of v) {
        if (
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === cov.Current.IdentityId
          ).length === 0
        ) {
          let classes = null;
          if (cov.CurrentCoverageEligibility) {
            classes = JSON.parse(cov.CurrentCoverageEligibility.Classes);
          }
          if (classes === null || classes === undefined) {
            classes = [];
          }
          if (
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnHasDependants ||
              (cov.CurrentCoverageEligibility.DependsOnHasDependants &&
                this.member.PersonalInfo.HasEligibleDependants === true)) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnCoverageStatus ||
              cov.CurrentCoverageEligibility.CoverageStatuses.filter(
                (o) =>
                  o.Id === this.member.MembershipStatus.DefaultCoverageStatus.Id
              ).length > 0) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnClass ||
              classes.filter((o) => o === this.member.MembershipStatus.Class)
                .length > 0) &&
            (!cov.CurrentCoverageEligibility ||
              !(cov.CurrentCoverageEligibility.BenefitParty === "Spouse") ||
              this.dependants.filter((o) => o.Relationship.IsSpouse).length >
                0) &&
            (!cov.CurrentCoverageEligibility ||
              !(cov.CurrentCoverageEligibility.BenefitParty === "Child") ||
              this.dependants.filter((o) => o.Relationship.IsChild).length > 0)
          ) {
            this.customizedCoverages.push({
              CoverageIdentity: cov,
              CoverageIdentityId: cov.Current.IdentityId,
              CoverageStatus: null,
              CoverageStatusId: null,
              EffectiveDate: this.member.MembershipStatus.EffectiveDate,
              Volume: null,
              COB: {},
            });
          }
        }
      }
      // this.benefitsProvider = new InMemoryProvider(
      //   this.customizedCoverages,
      //   BenefitHeaders
      // );
      // console.log("!@!@!@!@!@!@!@!@", this.customizedCoverages);
      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          o.CoverageIdentity.Current.IsWaivable ||
          o.CoverageIdentity.Current.HasCOB ||
          o.CoverageIdentity.Current.HasCoverageChoice ||
          o.CoverageIdentity.Current.HasVolumeChoice
      );
      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );

      this.$refs.benefitsTable.getDataAsync();
      this.$refs.nonCustomizedBenefitsTable.getDataAsync();
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    formatDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    deleteBeneficiaryStatement(options) {
      // console.log(options);
      this.beneficiariesProvider.items =
        this.beneficiariesProvider.items.filter((o) => o.Id !== options.Id);
      this.$refs.beneficiariesTable.getDataAsync();

      this.planInsuranceCarriers = this.allPlanInsuranceCarriers.filter(
        () => true
      );
      for (let statement of this.beneficiariesProvider.items) {
        this.planInsuranceCarriers = this.planInsuranceCarriers.filter(
          (o) =>
            statement.PlanInsuranceCarriers.filter((c) => c.Id === o.Id)
              .length === 0
        );
      }
      this.beneficiariesDialog = false;
    },
    tryDeleteBeneficiaryStatement(options) {
      // console.log(options);
      this.beneficiariesProvider.items =
        this.beneficiariesProvider.items.filter(
          (o) => o.Id !== options.statementId
        );
      this.$refs.beneficiariesTable.getDataAsync();

      this.planInsuranceCarriers = this.allPlanInsuranceCarriers.filter(
        () => true
      );
      for (let statement of this.beneficiariesProvider.items) {
        this.planInsuranceCarriers = this.planInsuranceCarriers.filter(
          (o) =>
            statement.PlanInsuranceCarriers.filter((c) => c.Id === o.Id)
              .length === 0
        );
      }
      this.beneficiariesDialog = false;
    },
    trySubmitBeneficiaries() {
      if (this.hasUnrevocable()) {
        this.$refs.beneficiariesForm.dialogs.unrevocable = true;
      } else {
        this.submitBeneficiaries();
      }
    },
    submitBeneficiaries() {
      if (
        this.$refs.beneficiariesForm === null ||
        this.$refs.beneficiariesForm === undefined
      ) {
        return;
      }
      var nItem = JSON.parse(
        JSON.stringify(this.$refs.beneficiariesForm.beneficiaryPayload)
      );
      console.log(nItem);
      nItem.Beneficiaries.map((b) => {
        b.Percentage = parseFloat(b.Percentage);
        b.Percentage = parseFloat((b.Percentage / 100).toFixed(4));
        return b;
      });
      var primaryPercentages = this.$refs.beneficiariesForm.percentages(
        true,
        nItem
      );
      if (primaryPercentages != 1 && primaryPercentages != null) {
        this.error = {
          customMessage: this.$t("errors.primary_percentage"),
        };
        return false;
      }
      var nonPrimaryPercentages = this.$refs.beneficiariesForm.percentages(
        false,
        nItem
      );
      if (nonPrimaryPercentages != 1 && nonPrimaryPercentages != null) {
        this.error = {
          customMessage: this.$t("errors.contingent_percentage"),
        };
        return false;
      }
      // nItem.memberIdentityId = this.id;
      console.log(JSON.stringify(nItem));

      let item = this.beneficiariesProvider.items.filter(
        (o) => o.Id === nItem.Id
      );
      console.log(JSON.stringify(item));
      if (item.length > 0) {
        const index = this.beneficiariesProvider.items.indexOf(item);
        this.beneficiariesProvider.items[index] = nItem;
      } else {
        this.beneficiariesProvider.items.push(nItem);
      }

      this.$refs.beneficiariesTable.getDataAsync();
      this.beneficiaryStatements = this.beneficiariesProvider.items.map((o) => {
        return {
          CurrentPolicies: o.PlanInsuranceCarriers.map((c) => c.Name).join(
            ", "
          ),
          PlanInsuranceCarriers: o.PlanInsuranceCarriers,
          Beneficiaries: o.Beneficiaries,
          DeclarationDate: o.DeclarationDate,
          Id: o.Id,
          DeclarationForm: nItem.DeclarationForm,
        };
      });

      this.planInsuranceCarriers = this.allPlanInsuranceCarriers.filter(
        () => true
      );
      for (let statement of this.beneficiariesProvider.items) {
        this.planInsuranceCarriers = this.planInsuranceCarriers.filter(
          (o) =>
            statement.PlanInsuranceCarriers.filter((c) => c.Id === o.Id)
              .length === 0
        );
      }
      this.beneficiariesDialog = false;
    },
    hasUnrevocable() {
      if (
        this.$refs.beneficiariesForm === null ||
        this.$refs.beneficiariesForm === undefined
      ) {
        return false;
      }
      return (
        this.$refs.beneficiariesForm.beneficiaryPayload.Beneficiaries.filter(
          (b) => !b.IsRevocable
        ).length > 0
      );
    },
    getName() {
      if (this.member.PersonalInfo) {
        if (
          this.member.PersonalInfo.FirstName &&
          this.member.PersonalInfo.LastName
        ) {
          return `${this.member.PersonalInfo.FirstName} ${this.member.PersonalInfo.LastName}`;
        } else if (this.member.PersonalInfo.FirstName) {
          return this.member.PersonalInfo.FirstName;
        } else if (this.member.PersonalInfo.LastName) {
          return this.member.PersonalInfo.LastName;
        }
      } else if (this.member.Certificate) {
        return this.member.Certificate;
      } else {
        return "";
      }
    },
    nextStep() {
      if (parseInt(this.step) === 1) {
        // console.log(this.benefitsProvider)
        if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
          this.refreshBenefits();
        }
      } else if (parseInt(this.step) === this.computeStep(4)) {
        // console.log(this.benefitsProvider)
        this.applyHireDate(true);
      }
      this.step++;
    },
    applyHireDate(checkValid) {
      if (this.member === null || this.member === undefined) {
        return;
      }
      if (
        this.member.MembershipStatus &&
        this.member.MembershipStatus.EffectiveDate
      ) {
        // console.log("sdjkhfasjkhsdjkf",  this.member.MembershipStatus.EffectiveDate);
        const valid = this.coverageAllowedDates(
          this.member.MembershipStatus.EffectiveDate
        );
        if ((checkValid && !valid) || !checkValid) {
          console.log(
            "skaldfjkasdasdksjdjaskldjklasjdkljaskldjaskldjklasjdkljaskldjaskdjklasjkld"
          );
          this.member.MembershipStatus.MemberGroupIdentity = {};
          this.member.MembershipStatus.EffectiveDate =
            this.computeCoverageEffectiveDate();
          this.customizedCoverages = [];
          this.optionalCoverage = [];
          this.benefitsProvider = undefined;
          this.nonCustomizedBenefitsProvider = undefined;
        }
      } else {
        // this.$nextTick(()=>{
        //   this.member.MembershipStatus.EffectiveDate = this.computeCoverageEffectiveDate();
        // })
        this.member.MembershipStatus.EffectiveDate =
          this.computeCoverageEffectiveDate();

        // console.log("effective date: ", this.member.MembershipStatus.EffectiveDate)
      }
    },
    computeCoverageEffectiveDate() {
      let d = null;
      // console.log(this.waiveWaitingPeriod, this.member.EmploymentInfo.HireDate);
      if (
        this.planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod &&
        this.member.EmploymentInfo.HireDate
      ) {
        // console.log(
        //   "has waiting period: ",
        //   this.planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod
        // );
        if (this.member.MembershipStatus.WaiveWaitingPeriod) {
          //hireDate
          d = this.member.EmploymentInfo.HireDate;
        } else {
          //hireDate +waitingPeriod
          let n2 = Date.parse(this.member.EmploymentInfo.HireDate);

          if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Month"
          ) {
            n2 = this.addMonths(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          } else if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Week"
          ) {
            n2 = this.addWeeks(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          } else if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Day"
          ) {
            n2 = this.addDays(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          }

          // new Date(n2)

          let dd = new Date(n2);
          const formatted = this.formatDate(dd);

          d = formatted;
        }
      } else if (
        Object.keys(this.headersDictionary).indexOf("Hire Date") > -1
      ) {
        //hireDate
        d = this.member.EmploymentInfo.HireDate;
      }
      // console.log(this.planIdentity.FirstRenewalDate);
      if (d === null) {
        return this.planIdentity.FirstRenewalDate;
      }
      const n = Date.parse(d);
      const d1 = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      if (d1 < d2) {
        return this.planIdentity.FirstRenewalDate;
      }
      return d;
    },
    isCoverageValid() {
      if (this.planIdentity.HasEligibilityBank) {
        return true;
      }
      if (
        this.benefitsProvider === null ||
        this.benefitsProvider === undefined ||
        this.nonCustomizedBenefitsProvider === null ||
        this.nonCustomizedBenefitsProvider === undefined
      ) {
        return true;
      }
      let valid = true;
      let benefits = JSON.parse(
        JSON.stringify(this.benefitsProvider.items)
      ).concat(
        JSON.parse(JSON.stringify(this.nonCustomizedBenefitsProvider.items))
      );
      // console.log(benefits);
      for (const benefit of benefits) {
        if (benefit.IsWaived) {
          valid = true;
        } else {
          if (benefit.CoverageIdentity.Current.HasCoverageChoice) {
            valid =
              benefit.CoverageStatus !== null &&
              benefit.CoverageStatus !== undefined;
            if (this.tracksDependantsByNumber(benefit)) {
              valid =
                benefit.NoOfDependants !== null &&
                benefit.NoOfDependants !== undefined;
            }
          }
          if (benefit.CoverageIdentity.Current.HasVolumeChoice) {
            valid = benefit.Volume !== null && benefit.Volume !== undefined;
          }
        }
        if (!valid) {
          break;
        }
      }
      return valid;
    },
    saveCob() {
      const item = this.benefitsProvider.items.filter(
        (o) => o.CoverageIdentityId === this.selectedBenefit.CoverageIdentityId
      )[0];
      const index = this.benefitsProvider.items.indexOf(item);
      // this.selectedBenefit.cobBool = true;
      this.benefitsProvider.items[index] = JSON.parse(
        JSON.stringify(this.selectedBenefit)
      );
      this.$refs.benefitsTable.getDataAsync();
      this.cobDialog = false;
      this.$forceUpdate();
    },
    saveCoverage() {
      const item = this.benefitsProvider.items.filter(
        (o) => o.CoverageIdentityId === this.selectedBenefit.CoverageIdentityId
      )[0];
      const index = this.benefitsProvider.items.indexOf(item);
      if (this.tracksDependantsByName(this.selectedBenefit)) {
        this.selectedBenefit.NoOfDependants =
          this.selectedBenefit.Dependants.length;
      }
      this.benefitsProvider.items[index] = JSON.parse(
        JSON.stringify(this.selectedBenefit)
      );
      this.$refs.benefitsTable.getDataAsync();
      this.editCoverageDialog = false;
      this.$forceUpdate();
    },
    contactInfoNext() {
      if (
        this.planIdentity.HasDrupalPortal &&
        this.planIdentity.MembersPortal !== undefined &&
        this.planIdentity.MembersPortal !== null &&
        this.planIdentity.MembersPortal.IsActive &&
        this.member.Email
      ) {
        this.color = "warning";
        this.message = this.$t(
          "components.addmemberwizard.email_portal_warning"
        );
        this.snackbar = true;
      }
      this.step++;
    },
    onConfirmEmailPaste(event) {
      // console.log("P A S T E: ", event);
      event.preventDefault();
      return false;
    },
    dateOfBirthDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d <= d2;
    },
    async saveMember() {
      console.log("save member called");
      this.saving = true;
      let member = JSON.parse(JSON.stringify(this.member));

      if (this.dependants) {
        let dependants = JSON.parse(JSON.stringify(this.dependants));
        member.Dependants = [];
        for (let dependant of dependants) {
          if (dependant.Student === null) {
            dependant.Student = false;
          }
          // dependant.Identity.Identifier = dependant.Identifier.toString();
          member.Dependants.push(dependant);
        }
        // delete member.CurrentDependants;
      }
      if (this.benefitsProvider) {
        member.CustomizedMemberBenefits = JSON.parse(
          JSON.stringify(this.benefitsProvider.items)
        );
      }
      if (this.nonCustomizedBenefitsProvider) {
        member.NonCustomizedMemberBenefits = JSON.parse(
          JSON.stringify(this.nonCustomizedBenefitsProvider.items)
        );
      }
      console.log(member.MemberBenefits);
      // for (let i = 0; i < member.MemberBenefits.length; i++) {
      //   // delete member.MemberBenefits[i].CoverageIdentity;
      //   member.MemberBenefits[i].EffectiveDate =
      //     member.MembershipStatus.EffectiveDate;
      //   if (Object.keys(member.MemberBenefits[i].COB).length === 0) {
      //     delete member.MemberBenefits[i].COB;
      //   } else {
      //     delete member.MemberBenefits[i].COB.cobBool;
      //   }
      //   if (
      //     member.MemberBenefits[i].Dependants !== null &&
      //     member.MemberBenefits[i].Dependants !== undefined
      //   ) {
      //     const depIds = JSON.parse(
      //       JSON.stringify(member.MemberBenefits[i].Dependants)
      //     );
      //     // delete member.MemberBenefits[i].Dependants;
      //     member.MemberBenefits[i].DependantIdentities = [];
      //     for (let depId of depIds) {
      //       const d = member.Dependants.filter(
      //         (o) => o.Identity.Identifier === depId.toString()
      //       )[0];
      //       member.MemberBenefits[i].DependantIdentities.push(d.Identity);
      //     }
      //   }
      // }
      if (
        Object.keys(member.MembershipStatus.MemberGroupIdentity).length === 0
      ) {
        delete member.MembershipStatus.MemberGroupIdentity;
      }

      member.IsEditable = true;

      this.$emit("save-in-dialog", member);
      this.saving = false;
    },
    async save() {
      console.log("save called");
      if (this.member.BankAccount) {
        if (Object.keys(this.member.BankAccount).length > 0) {
          this.saving = true;
          try {
            const valid = (
              await this.validateBankAccount({
                payload: {
                  InstitutionNumber: this.member.BankAccount.InstitutionNumber,
                  TransitNumber: this.member.BankAccount.TransitNumber,
                },
              })
            ).data;

            if (!valid) {
              this.confirmBankAccountDialog = true;
            } else {
              await this.saveMember();
            }
          } catch (error) {
            this.error = error;
          } finally {
            this.saving = false;
          }
        } else {
          this.saveMember();
        }
      } else {
        this.saveMember();
      }
    },
    close() {
      this.$emit("new-member-saved");
    },
    showLastBtn() {},
    stepExists(step) {
      switch (step) {
        case 2:
          //
          return false;
        case 3:
          // return (
          //   Object.keys(this.headersDictionary).indexOf("Account Number") >
          //     -1 ||
          //   Object.keys(this.headersDictionary).indexOf("Transit Number") >
          //     -1 ||
          //   Object.keys(this.headersDictionary).indexOf("Institution Number") >
          //     -1 ||
          //   Object.keys(this.headersDictionary).indexOf("Account Type") > -1 ||
          //   Object.keys(this.headersDictionary).indexOf(
          //     "Verify Direct Deposit"
          //   ) > -1
          // );
          return false;
        case 7:
          return (
            Object.keys(this.headersDictionary).indexOf(
              "CoverageConfiguration"
            ) > -1 &&
            (!this.hasCoverageCommencementRules ||
              this.overrideCommencementRules)
          );
        case 8:
          return (
            this.planOptions.HasBeneficiaries &&
            (!this.hasCoverageCommencementRules ||
              this.overrideCommencementRules)
          );
        default:
          return false;
      }
    },
    computeStep(step) {
      switch (step) {
        case 3:
          if (this.stepExists(2)) return 3;
          else return 2;
        case 4:
          if (this.stepExists(2)) {
            if (this.stepExists(3)) return 4;
            else return 3;
          } else {
            if (this.stepExists(3)) return 3;
            else return 2;
          }
        case 5:
          if (this.stepExists(2)) {
            if (this.stepExists(3)) return 5;
            else return 4;
          } else {
            if (this.stepExists(3)) return 4;
            else return 3;
          }
        case 6:
          if (this.stepExists(2)) {
            if (this.stepExists(3)) {
              return 6;
            } else return 5;
          } else {
            if (this.stepExists(3)) {
              return 5;
            } else {
              return 4;
            }
          }
        case 7:
          if (this.stepExists(2)) {
            if (this.stepExists(3)) {
              return 7;
            } else return 6;
          } else {
            if (this.stepExists(3)) {
              return 6;
            } else {
              return 5;
            }
          }
        case 8:
          if (this.stepExists(2)) {
            if (this.stepExists(3)) {
              if (this.stepExists(7)) return 8;
              else return 7;
            } else {
              if (this.stepExists(7)) return 7;
              else return 6;
            }
          } else {
            if (this.stepExists(3)) {
              if (this.stepExists(7)) return 7;
              else return 6;
            } else {
              if (this.stepExists(7)) return 6;
              else return 5;
            }
          }
        default:
          return parseInt(step);
      }
    },
    trans(item) {
      return translate(item, this.language.language);
    },
    trans2(item, field, transPropertyName) {
      return transPropertyName !== null && transPropertyName !== undefined
        ? translate2(item[transPropertyName], field)
        : translate2(item, field);
    },
    columnRules(column, mask) {
      // console.log(column.value, mask);
      let rules = [];
      if (column.isOptional === false) {
        if (column.type === "double" || column.type === "int") {
          rules.push(this.$rules.requiredNum);
        } else {
          rules.push(this.$rules.required);
        }
      }
      if (column.validationPattern) {
        if (mask) {
          rules.push((v) => {
            let val = this.unmask(v, mask);
            // console.log("regex: ", val);
            return (
              !val ||
              new RegExp(column.validationPattern).test(String(val)) ||
              this.$t("validation." + column.validationMessage)
            );
          });
        } else {
          rules.push((v) => {
            //console.log("regex: ",v)
            return (
              !v ||
              new RegExp(column.validationPattern).test(String(v)) ||
              this.$t("validation." + column.validationMessage)
            );
          });
        }
      }
      return rules;
    },
    allowedFirstRenewal(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      // if (this.term) {
      //   const n3 = Date.parse(this.term.EndDate);
      //   const d3 = new Date(n3);
      //   return d >= d2 && d < d3;
      // }
      // console.log(d, d2, d>=d2);
      return d >= d2;
    },
    allowedEnrollmentSignedAt(val) {
      if (
        this.member.EnrollmentSignedAt === null ||
        this.member.EnrollmentSignedAt === undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.member.EnrollmentSignedAt);
      const d2 = new Date(n2);
      return d >= d2;
    },
    // CoverageEffectiveDate allowed rules
    // #1. CoverageEffectiveDate >= FirstRenewalDate
    // #2. If WaitingPeriod then CoverageEffectiveDate >= max(hireDate + watingPeriod, FirstRenewalDate)
    // #3. If !WaitingPeriod then
    //        if hireDate then CoverageEffectiveDate >= max(hireDate, FirstRenewalDate)
    //        else CoverageEffectiveDate >= FirstRenewalDate
    coverageAllowedDates(currentDateString) {
      const currentTimestamps = Date.parse(currentDateString);
      const currentDate = new Date(currentTimestamps);
      let firstRenewalTimestamps = Date.parse(
        this.planIdentity.FirstRenewalDate
      );
      let hireTimestamps = null;
      if (
        this.planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod &&
        !this.member.MembershipStatus.WaiveWaitingPeriod
      ) {
        hireTimestamps = Date.parse(this.member.EmploymentInfo.HireDate);
        if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Month"
        ) {
          hireTimestamps = this.addMonths(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        } else if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Week"
        ) {
          hireTimestamps = this.addWeeks(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        } else if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Day"
        ) {
          hireTimestamps = this.addDays(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        }
      } else if (
        Object.keys(this.headersDictionary).indexOf("Hire Date") > -1
      ) {
        //hireDate
        hireTimestamps = Date.parse(this.member.EmploymentInfo.HireDate);
      }
      const firstRenewalDate = new Date(firstRenewalTimestamps);

      if (hireTimestamps !== null) {
        const hireDate = new Date(hireTimestamps);
        if (hireDate > firstRenewalDate) {
          return currentDate >= hireDate;
        }
      }
      return currentDate >= firstRenewalDate;
    },
    coverageExpireAllowedDates(val) {
      if (
        this.member.MembershipStatus.EffectiveDate === null ||
        this.member.MembershipStatus.EffectiveDate === undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.member.MembershipStatus.EffectiveDate);
      const d2 = new Date(n2);
      return d > d2;
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setUTCDate(result.getUTCDate() + days);
      return result;
    },
    addWeeks(date, weeks) {
      var result = new Date(date);
      result.setUTCDate(result.getUTCDate() + weeks * 7);
      return result;
    },
    addMonths(date, months) {
      var result = new Date(date);
      result.setUTCMonth(result.getUTCMonth() + months);
      return result;
    },
    isValid() {
      if (this.member === null || this.member === undefined) {
        this.$emit("valid-changed", false);
        return false;
      }
      console.log(
        "isValid: ",
        this.valid.personalInfo &&
          this.valid.employmentInfo &&
          // this.isContactInfoValid() &&
          // this.isBankAccountValid() &&
          this.valid.membershipStatus &&
          this.isMembershipStatus2Valid(),
        this.isCoverageValid()
      );
      console.log(this.valid.personalInfo);
      console.log(this.valid.employmentInfo);
      // console.log(this.isContactInfoValid());
      // console.log(this.isBankAccountValid());
      console.log(this.valid.membershipStatus);
      console.log(this.isMembershipStatus2Valid());
      console.log(this.isCoverageValid());
      // if (this.$refs.form2) {
      //   this.$refs.form2.validate();
      // }
      const valid =
        this.valid.personalInfo &&
        this.valid.employmentInfo &&
        // this.isContactInfoValid() &&
        // this.isBankAccountValid() &&
        this.valid.membershipStatus &&
        this.isMembershipStatus2Valid() &&
        this.isCoverageValid();
      this.$emit("valid-changed", valid);
      //console.log(valid);
      return valid;
    },
    isMembershipStatus2Valid() {
      if (
        this.member.MembershipStatus === null ||
        this.member.MembershipStatus === undefined ||
        (this.hasCoverageCommencementRules && !this.overrideCommencementRules)
      ) {
        return true;
      }
      let valid = this.member.MembershipStatus.MemberGroupIdentity.Current !== null &&
          this.member.MembershipStatus.MemberGroupIdentity.Current !== undefined;;
      if (Object.keys(this.headersDictionary).indexOf("Default Coverage Status") > -1) {
        valid = valid &&
          this.member.MembershipStatus.DefaultCoverageStatus !== null &&
          this.member.MembershipStatus.DefaultCoverageStatus !== undefined;
      }
      if (Object.keys(this.headersDictionary).indexOf("Class") > -1) {
        valid =
          valid &&
          this.member.MembershipStatus.Class !== null &&
          this.member.MembershipStatus.Class !== undefined;
      }
      return valid;
    },
    isContactInfoValid() {
      if (this.member === null || this.member === undefined) {
        return false;
      }
      // console.log(
      //   "isContactInfoValid: ",
      //   (Object.keys(this.member.ContactInfo).length > 1 ||
      //     Object.keys(this.member.ContactInfo.Address).length > 0) &&
      //     this.valid.contactInfo &&
      //     this.isAddressValid() &&
      //     this.valid.contactInfo2
      // );
      // console.log(this.valid.contactInfo);
      // console.log(this.isAddressValid());
      // console.log(this.valid.contactInfo2);
      // console.log(
      //   Object.keys(this.member.ContactInfo).length > 0 ||
      //     Object.keys(this.member.ContactInfo.Address).length > 0
      // );
      return (
        (Object.keys(this.member.ContactInfo).length > 0 ||
          Object.keys(this.member.ContactInfo.Address).length > 0) &&
        this.valid.contactInfo &&
        this.valid.contactInfo2 &&
        this.isAddressValid()
      );
    },
    isAddressValid() {
      // console.log("isAddressValid: ", );
      if (this.member === null || this.member === undefined) {
        return false;
      }
      if (Object.keys(this.member.ContactInfo.Address).length > 0) {
        return this.valid.address;
      }
      return true;
    },
    isBankAccountValid() {
      if (Object.keys(this.member.BankAccount).length > 0) {
        return this.valid.bankAccount;
      }
      if (this.$refs.bankAccountForm) {
        this.$refs.bankAccountForm.resetValidation();
      }
      return true;
    },
    hasCustomizableCoverages() {
      // console.log("hasCustomizableCoverage");
      var member = this.member;
      if (
        member.MembershipStatus.MemberGroupIdentity !== null &&
        member.MembershipStatus.MemberGroupIdentity !== undefined &&
        member.MembershipStatus.MemberGroupIdentity.Current !== null &&
        member.MembershipStatus.MemberGroupIdentity.Current !== undefined &&
        member.MembershipStatus.MemberGroupIdentity.Current.CoverageIdentities
      ) {
        var coverages =
          member.MembershipStatus.MemberGroupIdentity.Current
            .CoverageIdentities;
        var optOutCoverages = member.MembershipStatus.OptOutCoverageIdentities
          ? member.MembershipStatus.OptOutCoverageIdentities
          : [];
        var customizableCoverages = coverages.filter((c) => {
          var dependsOnFamilyStatus = c.Current.HasCoverageChoice;
          var isOptOut =
            optOutCoverages && optOutCoverages.some((ooc) => ooc.Id === c.Id);
          return dependsOnFamilyStatus && !isOptOut;
        });
        var customizableCoveragesVolumeChoice = coverages.filter((c) => {
          var hasVolumeChoice = c.Current.HasVolumeChoice;
          var isOptOut =
            optOutCoverages && optOutCoverages.some((ooc) => ooc.Id === c.Id);
          return hasVolumeChoice && !isOptOut;
        });
        return (
          customizableCoverages.length > 0 ||
          customizableCoveragesVolumeChoice.length > 0
        );
      }
      return false;
    },
    async loadCoverageConfiguration(coverage, effectiveDate) {
      //console.log(coverage, effectiveDate);
      if (this.loadingCoverageConfiguration) {
        setTimeout(() => {
          this.loadCoverageConfiguration(coverage, effectiveDate);
        }, 100);
      } else {
        this.loadingCoverageConfiguration = true;

        if (effectiveDate) {
          let coverageIds = [];
          if (coverage) {
            coverage.forEach((o) => {
              coverageIds.push("(CoverageIdentityId eq " + o.Id + ")");
            });
          }
          //console.log(coverageIds);
          if (coverageIds.length > 0) {
            let filter = "&$filter=" + coverageIds.join("or");
            //console.log(effectiveDate);
            const [date] = effectiveDate.split("T");
            const [year, month, day] = date.split("-");
            let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
            let url =
              "plans/" +
              this.selectedPlan.Id +
              "/effectiveDate/" +
              dateFormatted +
              "/configuration-parameters" +
              "?$expand=Translations,Identity($select=HasHistory;$expand=ConfigurationParameterValueIdentities($expand=Current($select=Value,Id,SystemType,IdentityId,Identity)))&$select=IdentityId,Description,ParameterType,EffectiveDate" +
              filter;
            this.coverageConfigurationLoading = true;
            try {
              this.coverageConfiguration = (
                await this.getCoverageConfiguration(url)
              ).data.value;
              this.coverageConfigurationLoading = false;
            } catch (error) {
              this.error = error;
            }
          } else {
            this.coverageConfiguration = [];
          }
        }
        this.loadingCoverageConfiguration = false;
      }
    },
    async getSelectableFamilyStatus(id) {
      try {
        const res = await ApiService.get("/settings/familyStatusHierarchy");
        this.selectableFamilyStatuses = res.data[id];
      } catch (err) {
        this.error = err;
        // console.log("err: ", err);
      }
    },
    tracksDependantsByNumber(cov) {
      return cov.CoverageIdentity.Current.TracksDependants === false;
    },
    tracksDependantsByName(cov) {
      return cov.CoverageIdentity.Current.TracksDependants === true;
    },
    selectableNoOfDependants(coverageStatus) {
      switch (coverageStatus.Name) {
        case "Family":
          return [1, 2, 3, 4, 5, 6];
        case "Single Parent":
          return [1, 2, 3, 4, 5, 6];
        case "Couple":
          return [1];
        default:
          return [0];
      }
    },
    cancelRate() {
      // this.snack = true;
      // this.snackColor = "error";
      // this.snackText = "Canceled";
    },
    closeRate() {
      //console.log("Dialog closed");
    },
    valueDisplayFunc(item, edit) {
      // console.log(JSON.stringify(item), edit);
      let cvalue = null;
      if (
        item.Identity &&
        item.Identity.ConfigurationParameterValueIdentities
      ) {
        let configurationParameterValue;
        //console.log("item.Identity.ConfigurationParameterValueIdentities")
        //console.log(JSON.stringify(item.Identity.ConfigurationParameterValueIdentities))

        configurationParameterValue =
          item.Identity.ConfigurationParameterValueIdentities.filter(
            (o) => o.MembershipStatusId === null
          );
        //console.log(configurationParameterValue, edit);
        if (
          configurationParameterValue[configurationParameterValue.length - 1]
            .dirty === true
        )
          item.isCustom = "Custom";
        else item.isCustom = "Default";
        cvalue =
          configurationParameterValue[configurationParameterValue.length - 1];

        if (configurationParameterValue.length > 0) {
          //console.log("Type: ", item.ParameterType, edit);
          if (item.ParameterType === "Amount" && !edit) {
            var val = cvalue.Current.Value;

            var value = parseFloat(val);
            //console.log(typeof value, edit);
            if (typeof value !== "number") {
              return value;
            }
            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
            });
            return formatter.format(value);
          }
          if (item.ParameterType === "Percentage") {
            if (edit) {
              return (parseFloat(cvalue.Current.Value) * 100).toFixed(2);
            } else {
              return (parseFloat(cvalue.Current.Value) * 100).toFixed(2) + "%";
            }
          }
          //console.log(cvalue.Current.Value, edit);
          return cvalue.Current.Value;
        }
      }
      return "";
    },
    inlineKeydown(evt) {
      if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    openRate(item) {
      //console.log("open inline edit: ", item);
      this.editedValue = this.valueDisplayFunc(item, true);
    },
    saveRate(item) {
      // console.log(
      //   "save inline edit: ",
      //   JSON.stringify(item),
      //   this.parameterValid
      // );
      if (this.parameterValid) {
        if (item.Identity.ConfigurationParameterValueIdentities) {
          let configurationParameterValue;
          configurationParameterValue =
            item.Identity.ConfigurationParameterValueIdentities.filter(
              (o) => o.MembershipStatusId === null
            );
          if (configurationParameterValue.length > 0) {
            //console.log(configurationParameterValue);
            let newConfParam = JSON.parse(
              JSON.stringify(configurationParameterValue[0])
            );
            newConfParam.Current.Value = this.editedValue;
            //console.log(JSON.stringify(newConfParam));
            if (item.ParameterType === "Percentage") {
              const val = parseInt(this.editedValue);
              if (!isNaN(val)) {
                newConfParam.Current.Value = val / 100;
              }
            }
            newConfParam.dirty = true;

            // if (
            //   item.Identity.ConfigurationParameterValueIdentities.length > 1
            // ) {
            //   //console.log(JSON.stringify(item.Identity.ConfigurationParameterValueIdentities));
            //   /*item.Identity.ConfigurationParameterValueIdentities.splice(
            //     1,
            //     item.Identity.ConfigurationParameterValueIdentities.length - 1
            //   );*/
            //   item.Identity.ConfigurationParameterValueIdentities = item.Identity.ConfigurationParameterValueIdentities.filter(
            //     (o) => o.MemberId !== this.member.Id
            //   );
            //   //console.log(JSON.stringify(item.Identity.ConfigurationParameterValueIdentities));
            // }TODO
            item.Identity.ConfigurationParameterValueIdentities.push(
              newConfParam
            );
            item.isCustom = "Custom";
            // console.log(
            //   JSON.stringify(
            //     item.Identity.ConfigurationParameterValueIdentities
            //   )
            // );
          }
        }
      }
      this.editedValue = -1.0;
    },
    resetToDefault(item) {
      //console.log(item);
      if (item.Identity.ConfigurationParameterValueIdentities) {
        let configurationParameterValue =
          item.Identity.ConfigurationParameterValueIdentities.filter(
            (o) => o.dirty === true
          );
        // if (configurationParameterValue.length === 0) {
        //   configurationParameterValue = item.Identity.ConfigurationParameterValueIdentities.filter(
        //     (o) => o.MemberId === this.member.Id
        //   );
        // }TODO
        if (configurationParameterValue.length > 0) {
          item.Identity.ConfigurationParameterValueIdentities.splice(
            item.Identity.ConfigurationParameterValueIdentities.indexOf(
              configurationParameterValue[0]
            ),
            1
          );
          item.isCustom = "Default";
        } else {
          //console.log(wtf);
        }
      }
    },
    dependantsChangedUpdated(item) {
      // console.log("updated: ", item);
      if (item.Id) {
        let updated = this.dependants.filter((o) => o.Id === item.Id)[0];
        let index = this.dependants.indexOf(updated);
        // console.log(index);
        this.dependants[index] = item;
      } else {
        let updated = this.dependants.filter(
          (o) => o.Identifier === item.Identifier
        )[0];
        let index = this.dependants.indexOf(updated);
        this.dependants[index] = item;
      }
      this.$forceUpdate();
      // this.$refs.dependantsTable.refresh();
    },
    dependantsChangedAdded(item) {
      this.dependants.push(item);
      // this.$refs.dependantsTable.refresh();
    },
    dependantsChangedRemoved(item) {
      // console.log("deleted: ", item);
      if (item.Id) {
        let removed = this.dependants.filter((o) => o.Id === item.Id)[0];
        removed.EffectiveDate = item.EffectiveDate;
        removed.IsRemoved = true;
      } else {
        //this.dependants = this.dependants.filter(o=>o.FirstName !== item.FirstName && o.LastName !== item.LastName);
        let removed = this.dependants.filter(
          (o) => o.Identifier === item.Identifier
        )[0];
        removed.EffectiveDate = item.EffectiveDate;
        removed.IsRemoved = true;
      }
      this.$forceUpdate();
      // this.$refs.dependantsTable.refresh();
    },
    countryChanged(country) {
      // console.log(JSON.stringify(country), JSON.stringify(this.member.ContactInfo.Address.Country));
      if (country) {
        if (country.IsOther) {
          delete this.member.ContactInfo.Address.Province;
          delete this.member.ContactInfo.Address.PostalCode;
        } else {
          delete this.member.ContactInfo.Address.OtherCountry;
          delete this.member.ContactInfo.Address.OtherProvince;
          delete this.member.ContactInfo.Address.OtherPostalCode;
        }
      } else {
        this.member.ContactInfo.Address = {};
      }
      // this.$forceUpdate();
    },
    formatDateString(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    tryReleaseCertificate() {
      // console.log(
      //   "try release cert: ",
      //   this.memberIdentityId,
      //   this.planIdentity.AutogenerateCertificate
      // );
      // if (
      //   !this.recreate &&
      //   this.memberIdentityId === null &&
      //   this.planIdentity.AutogenerateCertificate &&
      //   (this.member.Certificate !== null || this.member.PensionMembershipId !== null)
      // ) {
      //   return this.releaseCertificate({
      //     planIdentityId: this.selectedPlan.Id,
      //     certificate: this.member.Certificate?this.member.Certificate:this.member.PensionMembershipId,
      //   });
      // }
      if (
        !this.recreate &&
        this.memberIdentityId === null &&
        this.planIdentity.AutogenerateCertificate
      ) {
        const certificates = [];
        if (
          this.member.Certificate !== null ||
          this.member.PensionMembershipId !== null
        ) {
          certificates.push(
            this.member.Certificate
              ? this.member.Certificate
              : this.member.PensionMembershipId
          );
        }
        const beneficiaryStatements = this.beneficiariesProvider
          ? this.beneficiariesProvider.items.map((o) => {
              delete o.Id;
              return o;
            })
          : [];
        for (let bs of beneficiaryStatements) {
          for (let b of bs.Beneficiaries) {
            if (b.PensionBeneficiaryId) {
              certificates.push(b.PensionBeneficiaryId);
            }
          }
        }
        for (let d of this.dependants) {
          if (d.PensionSpouseId) {
            certificates.push(d.PensionSpouseId);
          }
        }
        return this.releaseCertificate({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            Certificates: certificates,
          },
        });
      }
    },
    async loadPlanData() {
      try {
        let headers = (
          await this.getMembersManagementColumns(this.selectedPlan.Id)
        ).data
          .filter((o) => o.onCreate === "Edit")
          .sort((a, b) => {
            return a.order - b.order;
          });

        for (const header of headers) {
          this.headersDictionary[header.text] = header;
        }
        const data = (
          await this.getPendingHoursNewMember({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
            pendingHourReportIds: [this.rowId],
          })
        ).data;
        let member;
        if (
          data[Object.keys(data)[0]] !== null &&
          data[Object.keys(data)[0]] !== undefined &&
          data[Object.keys(data)[0]] !== ""
        ) {
          console.log(
            "-------------------------------------",
            data,
            Object.keys(data)[0]
          );
          member = data[Object.keys(data)[0]];

          this.beneficiariesStatements = member.BeneficiaryStatements;
        } else {
          member = {
            PersonalInfo: {},
            EmploymentInfo: {},
            ContactInfo: {
              Address: {},
            },
            BankAccount: {},
            MembershipStatus: {
              MemberGroupIdentity: {},
              EffectiveDate: this.termDate,
            },
          };
          this.beneficiariesStatements = [];
        }
        if (this.externalMember) {
          for (let key of Object.keys(this.externalMember)) {
            member[key] = this.externalMember[key];
          }
        }

        console.log(member);
        // if (member.BankAccount === null || member.BankAccount === undefined) {
        //   member.BankAccount = {};
        // }
        // if (member.ContactInfo === null || member.ContactInfo === undefined) {
        //   member.ContactInfo = {
        //     Address: {}
        //   };
        // } else {
        //   if (member.ContactInfo.Address === null || member.ContactInfo.Address === undefined) {
        //     member.ContactInfo.Address = {};
        //   }
        // }
        if (member.Dependants === null || member.Dependants === undefined) {
          member.Dependants = [];
        }
        if (
          member.EmploymentInfo === null ||
          member.EmploymentInfo === undefined
        ) {
          member.EmploymentInfo = {};
        }
        if (
          member.CustomizedMemberBenefits === null ||
          member.CustomizedMemberBenefits === undefined
        ) {
          member.CustomizedMemberBenefits = [];
        }
        if (
          member.NonCustomizedMemberBenefits === null ||
          member.NonCustomizedMemberBenefits === undefined
        ) {
          member.NonCustomizedMemberBenefits = [];
        }
        if (
          member.MembershipStatus === null ||
          member.MembershipStatus === undefined
        ) {
          member.MembershipStatus = {};
        }
        if (member.PersonalInfo === null || member.PersonalInfo === undefined) {
          member.PersonalInfo = {};
        }

        if (
          member.PersonalInfo.TitleId !== null &&
          member.PersonalInfo.TitleId !== undefined
        ) {
          member.PersonalInfo.Title = this.options.Models.Title.filter(
            (o) => o.Id === member.PersonalInfo.TitleId
          )[0];
        }
        if (
          member.PersonalInfo.PronounId !== null &&
          member.PersonalInfo.PronounId !== undefined
        ) {
          member.PersonalInfo.Pronoun = this.options.Models.Pronoun.filter(
            (o) => o.Id === member.PersonalInfo.PronounId
          )[0];
        }
        if (
          member.PersonalInfo.GenderId !== null &&
          member.PersonalInfo.GenderId !== undefined
        ) {
          member.PersonalInfo.Gender = this.options.Models.Gender.filter(
            (o) => o.Id === member.PersonalInfo.GenderId
          )[0];
        }

        if (
          member.PersonalInfo.MaritalStatusId !== null &&
          member.PersonalInfo.MaritalStatusId !== undefined
        ) {
          member.PersonalInfo.MaritalStatus =
            this.options.Models.MaritalStatus.filter(
              (o) => o.Id === member.PersonalInfo.MaritalStatusId
            )[0];
        }

        if (
          member.PersonalInfo.ProvinceOfResidenceId !== null &&
          member.PersonalInfo.ProvinceOfResidenceId !== undefined
        ) {
          member.PersonalInfo.ProvinceOfResidence =
            this.options.Models.Province.filter(
              (o) => o.Id === member.PersonalInfo.ProvinceOfResidenceId
            )[0];
        }

        if (
          member.PersonalInfo.SuffixId !== null &&
          member.PersonalInfo.SuffixId !== undefined
        ) {
          member.PersonalInfo.Suffix = this.options.Models.Suffix.filter(
            (o) => o.Id === member.PersonalInfo.SuffixId
          )[0];
        }

        if (
          member.PersonalInfo.ProvinceOfEmploymentId !== null &&
          member.PersonalInfo.ProvinceOfEmploymentId !== undefined
        ) {
          member.PersonalInfo.ProvinceOfEmployment =
            this.options.Models.Province.filter(
              (o) => o.Id === member.PersonalInfo.ProvinceOfEmploymentId
            )[0];
        }

        if (
          member.EmploymentInfo.EmployerId !== null &&
          member.EmploymentInfo.EmployerId !== undefined
        ) {
          member.EmploymentInfo.Employer = this.employers.filter(
            (o) => o.Id === member.EmploymentInfo.EmployerId
          )[0];
        }
        if (
          member.EmploymentInfo.StoreId !== null &&
          member.EmploymentInfo.StoreId !== undefined
        ) {
          member.EmploymentInfo.Store =
            member.EmploymentInfo.Employer.Stores.filter(
              (o) => o.Id === member.EmploymentInfo.StoreId
            )[0];
        }
        if (
          member.EmploymentInfo.EmploymentTypeId !== null &&
          member.EmploymentInfo.EmploymentTypeId !== undefined
        ) {
          member.EmploymentInfo.EmploymentType =
            this.options.Models.EmploymentType.filter(
              (o) => o.Id === member.EmploymentInfo.EmploymentTypeId
            )[0];
        }

        if (
          member.EmploymentInfo.EmploymentFrequencyId !== null &&
          member.EmploymentInfo.EmploymentFrequencyId !== undefined
        ) {
          member.EmploymentInfo.EmploymentFrequency =
            this.options.Models.EmploymentFrequency.filter(
              (o) => o.Id === member.EmploymentInfo.EmploymentFrequencyId
            )[0];
        }
        if (
          member.EmploymentInfo.EarningsFrequencyId !== null &&
          member.EmploymentInfo.EarningsFrequencyId !== undefined
        ) {
          member.EmploymentInfo.EarningsFrequency =
            this.options.Models.EarningsFrequency.filter(
              (o) => o.Id === member.EmploymentInfo.EarningsFrequencyId
            )[0];
        }
        if (
          member.EmploymentInfo.IncomeTypeId !== null &&
          member.EmploymentInfo.IncomeTypeId !== undefined
        ) {
          member.EmploymentInfo.IncomeType =
            this.options.Models.IncomeType.filter(
              (o) => o.Id === member.EmploymentInfo.IncomeTypeId
            )[0];
        }

        if (
          member.EmploymentInfo.SecondIncomeTypeId !== null &&
          member.EmploymentInfo.SecondIncomeTypeId !== undefined
        ) {
          member.EmploymentInfo.SecondIncomeEarningsFrequency =
            this.options.Models.SecondIncomeEarningsFrequency.filter(
              (o) => o.Id === member.EmploymentInfo.SecondIncomeTypeId
            )[0];
        }

        // if (member.ContactInfo.LanguageChoiceId!==null && member.ContactInfo.LanguageChoiceId!==undefined) {
        //   member.ContactInfo.LanguageChoice = this.options.Models.LanguageChoice.filter(o=>o.Id === member.ContactInfo.LanguageChoiceId)[0];
        // }
        // if (member.ContactInfo.CommunicationPreferenceId!==null && member.ContactInfo.CommunicationPreferenceId!==undefined) {
        //   member.ContactInfo.CommunicationPreference = this.options.Models.CommunicationPreference.filter(o=>o.Id === member.ContactInfo.CommunicationPreferenceId)[0];
        // }

        // if (member.ContactInfo.Address.CountryId!==null && member.ContactInfo.Address.CountryId!==undefined) {
        //   member.ContactInfo.Address.Country = this.options.Models.Country.filter(o=>o.Id === member.ContactInfo.Address.CountryId)[0];
        // }

        // if (member.ContactInfo.Address.ProvinceId!==null && member.ContactInfo.Address.ProvinceId!==undefined) {
        //   member.ContactInfo.Address.Province = this.options.Models.Province.filter(o=>o.Id === member.ContactInfo.Address.ProvinceId)[0];
        // }

        if (
          member.MembershipStatus.DefaultCoverageStatusId !== null &&
          member.MembershipStatus.DefaultCoverageStatusId !== undefined
        ) {
          member.MembershipStatus.DefaultCoverageStatus =
            this.options.Models.FamilyStatus.filter(
              (o) => o.Id === member.MembershipStatus.DefaultCoverageStatusId
            )[0];
        }

        if (
          member.MembershipStatus.EffectiveDate !== null &&
          member.MembershipStatus.EffectiveDate !== undefined
        ) {
          let planDetails = (
            await this.getPlanDetailsByDate({
              plan: this.selectedPlan.Id,
              date: member.MembershipStatus.EffectiveDate,
            })
          ).data;
          this.classes =
            planDetails && planDetails.Classes
              ? JSON.parse(planDetails.Classes)
              : [];

          this.memberGroups = (
            await this.getMemberGroupsWithDate({
              plan: this.selectedPlan.Id,
              date: member.MembershipStatus.EffectiveDate,
              url: "?$expand=Translations,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations,PlanInsuranceCarrier($expand=PolicyIdentity($expand=Current))))",
            })
          ).data.value;

          if (
            member.MembershipStatus.MemberGroupIdentityId !== null &&
            member.MembershipStatus.MemberGroupIdentityId !== undefined
          ) {
            let mg = this.memberGroups.filter(
              (o) =>
                o.IdentityId === member.MembershipStatus.MemberGroupIdentityId
            )[0];
            member.MembershipStatus.MemberGroupIdentity = {
              Current: mg,
            };
          }

          this.membershipStatusEffectiveDateLoaded = true;
          console.log("loading member true");
          this.loadingMember = true;
        }

        for (let dependant of member.Dependants) {
          if (
            dependant.RelationshipId !== null &&
            dependant.RelationshipId !== undefined
          ) {
            dependant.Relationship = this.options.Models.Relationship.filter(
              (o) => o.Id === dependant.RelationshipId
            )[0];
          }
          if (dependant.GenderId !== null && dependant.GenderId !== undefined) {
            dependant.Gender = this.options.Models.Gender.filter(
              (o) => o.Id === dependant.GenderId
            )[0];
          }
          if (dependant.SuffixId !== null && dependant.SuffixId !== undefined) {
            dependant.Suffix = this.options.Models.Suffix.filter(
              (o) => o.Id === dependant.SuffixId
            )[0];
          }
          if (dependant.TitleId !== null && dependant.TitleId !== undefined) {
            dependant.Title = this.options.Models.Title.filter(
              (o) => o.Id === dependant.TitleId
            )[0];
          }
          console.log(
            "----------------------------------------#########################",
            member.Dependants
          );

          // if (dependant.Identity.Identifier!==null&&dependant.Identity.Identifier!==undefined) {
          //   dependant.Identifier = dependant.Identity.Identifier;
          // }
        }
        if (member.Dependants !== null && member.Dependants !== undefined) {
          this.dependants = member.Dependants;
        } else {
          this.dependants = [];
        }

        // for (let i = 0; i < member.MemberBenefits.length; i++) {
        //   console.log(member.MemberBenefits[i])
        //   // delete member.MemberBenefits[i].CoverageIdentity;
        //   if (
        //     member.MemberBenefits[i].CoverageStatusId !== null &&
        //     member.MemberBenefits[i].CoverageStatusId !== undefined
        //   ) {
        //     member.MemberBenefits[i].CoverageStatus = this.options.Models.FamilyStatus.filter(o=>o.Id === member.MemberBenefits[i].CoverageStatusId)[0];
        //   }

        //   // if (
        //   //   member.MemberBenefits[i].Dependants !== null &&
        //   //   member.MemberBenefits[i].Dependants !== undefined
        //   // ) {
        //   //   const depIds = JSON.parse(
        //   //     JSON.stringify(member.MemberBenefits[i].Dependants)
        //   //   );
        //   //   delete member.MemberBenefits[i].Dependants;
        //   //   member.MemberBenefits[i].DependantIdentities = [];
        //   //   for (let depId of depIds) {
        //   //     const d = member.Dependants.filter(
        //   //       (o) => o.Identity.Identifier === depId.toString()
        //   //     )[0];
        //   //     member.MemberBenefits[i].DependantIdentities.push(d.Identity);
        //   //   }
        //   // }
        // }

        // console.log(this.planIdentity);
        if (this.planIdentity.AutogenerateCertificate && !this.recreate) {
          member.Certificate = (
            await this.getNewCertificate({
              planIdentityId: this.selectedPlan.Id,
              entity: "Member",
            })
          ).data.value;
        }

        //   this.beneficiaryStatements = member.BeneficiaryStatements;
        // console.log(this.beneficiaryStatements);
        // const usedInsuranceCarriers = [];
        // for (let bs of member.BeneficiaryStatements) {
        //   usedInsuranceCarriers.push(
        //     ...bs.PlanInsuranceCarriers.map((p) => p.Id)
        //   )
        // }

        // const planInsuranceCarriers = [];
        // for (const c of member.MemberBenefits) {
        //   console.log(c);
        //   if (
        //     c.CurrentBenefit &&
        //     c.CurrentBenefit.PlanInsuranceCarrier &&
        //     c.CurrentBenefit.PlanInsuranceCarrier.HasBeneficiaries &&
        //     c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity &&
        //     c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity.Current
        //   ) {
        //     const id = c.CurrentBenefit.PlanInsuranceCarrier.Id;
        //     const name =
        //       c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity.Current
        //         .Number;
        //     if (usedInsuranceCarriers.indexOf(id) === -1) {
        //       planInsuranceCarriers.push({
        //         Id: id,
        //         Name: name,
        //       });
        //       usedInsuranceCarriers.push(id);
        //     }
        //   }
        // }
        // this.planInsuranceCarriers = planInsuranceCarriers;

        let occupations = JSON.parse(this.selectedPlan.Occupations);
        this.occupations = occupations
          ? occupations.sort((a, b) => {
              return a.localeCompare(b);
            })
          : [];

        if (member.CustomizedMemberBenefits) {
          this.benefitsProvider = new InMemoryProvider(
            member.CustomizedMemberBenefits,
            BenefitHeaders
          );
          this.nonCustomizedBenefitsProvider = new InMemoryProvider(
            member.NonCustomizedMemberBenefits,
            NonCustomizedBenefitHeaders
          );
          this.createCustomCoverage = false;
        } else {
          this.createCustomCoverage = true;
        }

        this.member = member;
        console.log(this.member);
      } catch (error) {
        this.error = error;
      } finally {
        this.$nextTick(() => {
          setTimeout(() => {
            console.log("loading member false");
            this.loadingMember = false;
            this.isValid();
            if (this.$refs.personalInfoForm) {
              this.$refs.personalInfoForm.validate();
            }
          }, 1000);
        });
      }
    },

    async unload() {
      console.log("unload");
      try {
        await this.tryReleaseCertificate();
        console.log("Hello");
        this.sleep(1000);
        console.log("World!");
      } catch (error) {
        this.error = error;
      }
    },
  },
  watch: {
    valid: {
      handler(v) {
        this.isValid();
      },
      deep: true,
      immediate: true,
    },
    overrideCommencementRules: {
      handler(v) {
        if (v) {
          this.member.MembershipStatus.MemberGroupIdentity = {};
        } else {
          this.member.MembershipStatus.MemberGroupIdentity = null;
          this.member.MembershipStatus.DefaultCoverageStatus = null;
          this.member.MembershipStatus.Class = null;
        }
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    step: {
      handler(v) {
        if (this.$refs.personalInfoForm) {
          this.$refs.personalInfoForm.resetValidation();
        }
        if (this.$refs.employmentInfoForm) {
          this.$refs.employmentInfoForm.resetValidation();
        }
        if (this.$refs.contactInfoForm) {
          this.$refs.contactInfoForm.resetValidation();
        }
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.resetValidation();
        }
        if (this.$refs.addressForm) {
          this.$refs.addressForm.resetValidation();
        }
        if (this.$refs.bankAccountForm) {
          this.$refs.bankAccountForm.resetValidation();
        }
        if (this.step === null || this.step === undefined) {
          return;
        }
        if (this.step.toString() === this.computeStep(1).toString()) {
          setTimeout(() => {
            document.getElementById("member_creation_step1").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(2).toString()) {
          setTimeout(() => {
            document.getElementById("member_creation_step2").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(3).toString()) {
          setTimeout(() => {
            this.$nextTick(() => {
              document.getElementById("member_creation_step3").scrollIntoView({
                behavior: "smooth",
              });
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(4).toString()) {
          setTimeout(() => {
            document.getElementById("member_creation_step4").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(5).toString()) {
          setTimeout(() => {
            document.getElementById("member_creation_step5").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(6).toString()) {
          // this.refreshBenefits();
          setTimeout(() => {
            document.getElementById("member_creation_step6").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (
          this.stepExists(7) &&
          this.step.toString() === this.computeStep(7).toString() &&
          !this.coverageConfigurationLoaded
        ) {
          const coverage = this.benefitsProvider.items.concat(
            this.nonCustomizedBenefitsProvider.items
          );
          this.loadCoverageConfiguration(
            coverage.map((o) => o.CoverageIdentity),
            this.member.MembershipStatus.EffectiveDate
          );
          setTimeout(() => {
            document.getElementById("member_creation_step7").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        } else if (this.step.toString() === this.computeStep(8).toString()) {
          const planInsuranceCarriers = [];
          const coverage = this.benefitsProvider.items.concat(
            this.nonCustomizedBenefitsProvider.items
          );
          for (const c of coverage) {
            // console.log(c);
            if (
              c.CoverageIdentity &&
              c.CoverageIdentity.Current &&
              c.CoverageIdentity.Current.PlanInsuranceCarrier &&
              c.CoverageIdentity.Current.PlanInsuranceCarrier
                .HasBeneficiaries &&
              c.CoverageIdentity.Current.PlanInsuranceCarrier.PolicyIdentity &&
              c.CoverageIdentity.Current.PlanInsuranceCarrier.PolicyIdentity
                .Current
            ) {
              const id = c.CoverageIdentity.Current.PlanInsuranceCarrier.Id;
              const name =
                c.CoverageIdentity.Current.PlanInsuranceCarrier.PolicyIdentity
                  .Current.Number;
              if (
                planInsuranceCarriers.filter((o) => o.Id === id).length === 0
              ) {
                planInsuranceCarriers.push({
                  Id: id,
                  Name: name,
                });
              }
            }
          }
          this.allPlanInsuranceCarriers = planInsuranceCarriers;
          // console.log(this.planInsuranceCarriers);
          this.$nextTick(() => {
            this.planInsuranceCarriers = this.allPlanInsuranceCarriers.filter(
              () => true
            );
            for (let statement of this.beneficiariesProvider.items) {
              this.planInsuranceCarriers = this.planInsuranceCarriers.filter(
                (o) =>
                  statement.PlanInsuranceCarriers.filter((c) => c.Id === o.Id)
                    .length === 0
              );
            }
          });
          setTimeout(() => {
            document.getElementById("member_creation_step8").scrollIntoView({
              behavior: "smooth",
            });
          }, 750);
        }
        // this.$nextTick(()=>{
        //   function isHidden(el) {
        //     // console.log(el, el.offsetParent);
        //       return (el.offsetParent === null)
        //   }
        //   setTimeout(()=>{
        //     const steps = document.getElementsByClassName("v-stepper__step--active");
        //     console.log(steps);
        //     if (steps.length > 0) {
        //       const activeStepHeader = steps[0];
        //       const parentDiv = activeStepHeader.parentElement;
        //       const children = [...parentDiv.children];
        //       const index = children.indexOf(activeStepHeader);
        //       // console.log(children, activeStepHeader, index);
        //       const activeStepContent = children[index+1];
        //       // console.log(activeStepContent);
        //       const forms = activeStepContent.getElementsByTagName("form");
        //       // let visibleForms = [];
        //       console.log(forms);
        //       for (let i=0;i<forms.length;i++) {
        //         const form= forms.item(i);
        //         if (!isHidden(form)) {
        //           // visibleForms.push(form);
        //           console.log(form);
        //           const inputs = [...form.getElementsByClassName("v-input")];

        //           // for (let j=0;j<inputs.length;j++) {
        //           //   const inputField = inputs.item(j);
        //           //   // if (!isHidden(inputField)) {
        //           //     console.log(inputField);
        //           //     inputField.focus();
        //           //     break;
        //           //   // }
        //           // }
        //           break;
        //         }
        //       }
        //     }
        //   }, 200)
        //   // console.log(visibleForms);
        // });
      },
      immediate: true,
    },
    "member.EmploymentInfo.Employer": {
      async handler(v) {
        if (v) {
          this.hasCoverageCommencementRules =
            await this.checkHasCoverageCommencementRules({
              planId: this.selectedPlan.Id,
              employerId: this.member.EmploymentInfo.Employer.Id,
            });
          if (this.planOptions.HasStores) {
            if (v.Stores) {
              const collator = new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: "base",
              });
              this.stores = v.Stores.filter(
                (o) => o.IsAssignable !== false
              ).sort(collator.compare);
            }
            if (
              !v.Stores ||
              v.Stores.filter((o) =>
                this.member.EmploymentInfo.Store
                  ? o.Id === this.member.EmploymentInfo.Store.Id
                  : false
              ).length === 0
            ) {
              this.member.EmploymentInfo.Store = null;
              this.member.EmploymentInfo.StoreId = null;
            }
          }
        } else {
          this.stores = [];
          this.hasCoverageCommencementRules = true;
        }
      },
    },
    "member.ContactInfo.Country": {
      handler(v) {
        if (v) {
          if (this.member.ContactInfo.Address.Country.IsOther) {
            delete this.member.ContactInfo.Address.Province;
            delete this.member.ContactInfo.Address.PostalCode;
          } else {
            delete this.member.ContactInfo.Address.OtherCountry;
            delete this.member.ContactInfo.Address.OtherProvince;
            delete this.member.ContactInfo.Address.OtherPostalCode;
          }
        } else {
          this.member.ContactInfo.Address = {};
        }
      },
    },
    "member.MembershipStatus.EffectiveDate": {
      async handler(v) {
        console.log("effective date changed: ", v);
        if (v && !this.loadingMember) {
          console.log("effective date changed fired: ", v);
          try {
            let planDetails = (
              await this.getPlanDetailsByDate({
                plan: this.selectedPlan.Id,
                date: v,
              })
            ).data;
            this.classes =
              planDetails && planDetails.Classes
                ? JSON.parse(planDetails.Classes)
                : [];

            this.memberGroups = (
              await this.getMemberGroupsWithDate({
                plan: this.selectedPlan.Id,
                date: v,
                url: "?$expand=Translations,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations,PlanInsuranceCarrier($expand=PolicyIdentity($expand=Current))))",
              })
            ).data.value;

            this.membershipStatusEffectiveDateLoaded = true;

            console.log(
              "effective date lodaed: ",
              this.member.MembershipStatus
            );
            if (
              this.member.MembershipStatus.MemberGroupIdentity &&
              this.member.MembershipStatus.MemberGroupIdentity.Current &&
              this.createCustomCoverage
            ) {
              this.setCustomizableCoverages();
            }
            this.isValid();
          } catch (error) {
            this.error = error;
          }
        }
      },
      immediate: true,
    },
    "member.MembershipStatus.MemberGroupIdentity.Current": {
      handler(v) {
        if (this.membershipStatusEffectiveDateLoaded && !this.loadingMember) {
          console.log("member group changed: ", v);
          if (v) {
            // this.optionalCoverage = v.CoverageIdentities.filter(
            //   (o) => o.Current.IsOptional === true
            // );

            this.selectedOptionalCoverage = [];
            this.setCustomizableCoverages();
            this.isValid();
          }
        }
      },
      immediate: true,
    },
    "member.MembershipStatus.DefaultCoverageStatus": {
      async handler(v) {
        if (this.membershipStatusEffectiveDateLoaded && !this.loadingMember) {
          console.log("default coverage status: ", v);
          const coverageStatus = v ? v : {};
          await this.getSelectableFamilyStatus(coverageStatus.Id);
          if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
            this.refreshBenefits();
          }
          this.isValid();
        }
      },
    },
    "member.MembershipStatus.Class": {
      handler(v) {
        if (this.membershipStatusEffectiveDateLoaded && !this.loadingMember) {
          console.log("class status: ", v);
          if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
            this.refreshBenefits();
          }
          this.isValid();
        }
      },
    },
    "member.PersonalInfo.HasEligibleDependants": {
      handler(v) {
        if (this.membershipStatusEffectiveDateLoaded && !this.loadingMember) {
          console.log("fas eleigible dependants status: ", v);
          if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
            this.refreshBenefits();
          }
          this.isValid();
        }
      },
    },
    "member.EnrollmentSignedAt": {
      handler() {
        if (
          this.member !== null &&
          this.member !== undefined &&
          this.member.EnrollmentReceivedAt !== null &&
          this.member.EnrollmentReceivedAt !== undefined
        ) {
          this.$refs.personalInfoForm &&
            this.$refs.personalInfoForm.resetValidation();
        }
      },
      immediate: true,
    },
    "member.EnrollmentReceivedAt": {
      handler() {
        if (
          this.member !== null &&
          this.member !== undefined &&
          this.member.EnrollmentSignedAt !== null &&
          this.member.EnrollmentSignedAt !== undefined
        ) {
          this.$refs.personalInfoForm &&
            this.$refs.personalInfoForm.resetValidation();
        }
      },
      immediate: true,
    },
    // "member.Email": {
    //   handler() {
    //     // console.log("email");
    //     if (this.$refs.contactInfoForm2) {
    //       // console.log("contact info 2 validate");
    //       this.$refs.contactInfoForm2.validate();
    //     }
    //     this.$forceUpdate();
    //   },
    //   immediate: true,
    // },
    // confirmEmail: {
    //   handler() {
    //     // console.log("email confirm");
    //     if (this.$refs.contactInfoForm2) {
    //       // console.log("contact info 2 validate");
    //       this.$refs.contactInfoForm2.validate();
    //     }
    //     this.$forceUpdate();
    //   },
    //   immediate: true,
    // },
    "member.MembershipStatus.WaiveWaitingPeriod": {
      handler(v) {
        if (this.membershipStatusEffectiveDateLoaded && !this.loadingMember) {
          console.log("waive waitibg period: ", v);
          this.applyHireDate(false);
        }
      },
      immediate: true,
    },
    // "member.BankAccount.InstitutionNumber": {
    //   handler(v) {
    //     if (v === "") {
    //       delete this.member.BankAccount.InstitutionNumber;
    //     }
    //   },
    // },
    // "member.BankAccount.AccountNumber": {
    //   handler(v) {
    //     if (v === "") {
    //       delete this.member.BankAccount.AccountNumber;
    //     }
    //   },
    // },
    // "member.BankAccount.TransitNumber": {
    //   handler(v) {
    //     if (v === "") {
    //       delete this.member.BankAccount.TransitNumber;
    //     }
    //   },
    // },
    member: {
      handler(v) {
        this.isValid();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("plansMembers", ["options", "planIdentity", "planOptions"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
    dependantsList() {
      return this.dependants.map((o) => `${o.FirstName} ${o.LastName}`);
    },
    singleFamilyStatus() {
      return this.options.Models.FamilyStatus.filter(
        (o) => o.Name === "Single"
      )[0];
    },
    coupleFamilyStatus() {
      return this.options.Models.FamilyStatus.filter(
        (o) => o.Name === "Couple"
      )[0];
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      console.log("m o u n t e d : ");
      this.loadPlanData();
    }
  },
  created() {
    window.addEventListener("beforeunload", this.unload, { capture: true });
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  // async beforeRouteLeave(to, from, next) {
  //   try {
  //     await this.tryReleaseCertificate();
  //   } catch (error) {
  //     this.error = error;
  //   }
  //   next();
  // },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.member-view /deep/ .v-list-group__items > .v-list-item {
  padding-left: 45px;
}
</style>
<style>
.date-picker-textbox {
  display: inline-flex;
}
</style>
<style>
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: fit-content;
  background-color: white;
  color: black;
  text-align: center;
  /* border-radius: 6px; */
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
